import {Injectable} from '@angular/core';
import {Actions, CreateEffectMetadata, createEffect, ofType} from '@ngrx/effects';
import {concatLatestFrom} from '@ngrx/operators';
import {FirebaseService} from '../../../shared-utilities/services-old/firebase.service';
import * as StockManagerActions from '../store/stock-manager.actions';
import {catchError, concatMap, exhaustMap, filter, map, mergeMap, switchMap, take, tap, withLatestFrom} from 'rxjs/operators';
import {
  sItemIntToKey,
  sItemKeyToInt,
  StockItem, StockItemUpdateObj,
  Supplier,
  VatRates,
} from '../../../shared-utilities/models-old/datastructures';
import {
  IAdvancedFilterGroup,
  IDisableStockItemRule,
  IEnableStockItemRule,
  normalizeDisableStockItemRuleFromFirestore,
} from '../../settings-new/models';
import {settingStockItemEnableRules} from '../../settings-new/store/setting.actions';
import {combineLatest, concat, EMPTY, firstValueFrom, forkJoin, from, Observable, of, throwError, toArray} from 'rxjs';
import {Action, select, Store} from '@ngrx/store';
import {TypeSenseService} from '../../../shared/shared-services/type-sense/type-sense.service';
import {IPaginationData} from '../../../shared/shared-models/pagination/pagination-data';

import {
  IFacetCounts,
  ITypeSenseApiDoc,
  TypeSenseHit,
  TypesenseQueryData,
  TypeSenseSearchResponse,
} from '../../../shared/shared-models/type-sense/type-sense-types';
import {DEFAULT_SEARCHABLE_FIELDS, ISearchableFields} from '../../../shared/shared-models/type-sense/default-searchable-fields';
import {IDepartment} from '../../../shared/shared-models/stock/departments';
import {
  createFacetCountsMap,
  hasStringPresenceAdvancedFilters,
  mapTypeSenseObjectToGeneric,
} from '../../../shared/shared-utils/typesense-utils/typesense.utils';
import {createMapFromObjectsObject, getDeepCopyOfObject} from '../../../shared/shared-utils/object/object.utils';
import {
  calculateGPFromPrice,
  calculatePriceFromGpValue,
  getMonthlyAverage,
} from '../../../shared/shared-utils/calculations/calculations-stock';
import {
  applyPriceBanding,
  PRICE_BANDING_COLUMNS_FOR_NGP_REPORTS,
} from '../../../shared/shared-utils/price/price-banding.utils';
import {
  applyMultiplePriceChangesToStockItem,
  hasActiveMultiplePriceChangeRules,
  restoreMultiplePriceChangeFieldsToOriginal,
} from '../../../shared/shared-utils/price/multiple-price-change.utils';
import {
  selectFeatureStockRulesSettings,
  selectSelectedStoreMultiplePriceChangeRules,
} from '../../settings-new/store/setting.selectors';
import {createDefaultMultiplePriceChangeSettings} from '../../../shared/shared-utils/price/multiple-price-change.utils';
import {
  selectAllSharedGridVatRates,
  selectPriceBandingForAllStores,
  selectPriceBandingForUserSelectedStore,
  selectSharedGridVatRateBySelectedStore,
} from '../../../shared-modules/shared-grid/store/shared-grid.selectors';
import {IPriceBand} from '../../../shared/shared-models/price-banding/price-band';
import {
  applyStoreColoursToStockItems,
  buildStoreColourMap,
  getPrefixNeededForPage,
  filtersWithoutSupplierSelection,
  getStoreScopedFilters,
  IMultiStoreHitRow,
  isMultiStorePageBeyondPrefixCap,
  mergeFacetCounts,
  MULTI_STORE_PREFIX_CAP,
  MULTI_STORE_TYPESENSE_PAGE_SIZE,
  scopeSupplierFacetCountsToStore,
  supplierFacetCountsOnly,
  sortMultiStoreHits,
} from '../utils/stock-manager-multi-store.utils';
import {MULTI_STORE_SYNTHETIC_STORE} from './stock-manager.selectors';
import {
  path_stores_storeId_settings_disable_stock_item_rules,
  path_stores_storeId_settings_enable_stock_item_rules,
  path_users_userId_settings_stock_edits_preview,
} from '../../../shared/shared-services/database-paths';
import {
  CollectionUsersSettingsService,
} from '../../../shared/shared-services/firebase/collection-users-settings.service';
import {SharedModalUtils} from '../../../shared/shared-utils/shared-modal/shared-modal.utils';
import {ISharedModalBasic, ISharedModalBasicResponse} from '../../../shared/shared-models/modals/shared-modal-basic';
import {IconColourEnum} from '../../../shared-modules/shared-icons/models/icons-colour.enum';
import {CollectionStoresDocsService} from '../../../shared/shared-services/firebase/collection-stores-docs.service';
import {
  CollectionStoresSettingsService,
} from '../../../shared/shared-services/firebase/collection-stores-settings.service';

import {clearEditedItemsInLocalStorage} from '../../ngp-report/store/ngp-report.effects.utils';
import {
  CollectionSharedSingularDocumentsService,
} from '../../../shared/shared-services/firebase/collection-shared-singular-documents.service';
import {ISharedStoreSettings} from '../../../shared/shared-models/firebase/shared-store-settings';
import {AO_KEY_2_TITLE} from '../../auto-ordering/models/old-models/auto-order-types';
import {PropertyToTitle} from '../../../shared/shared-utils/conversions/properties';
import {convertToDecimal} from '../../../shared/shared-utils/number/number.utils';
import * as AutoOrderActions from '../../auto-ordering/store/auto-ordering.actions';
import * as StockManagerSelectors from './stock-manager.selectors';
import {
  selectDontDisplayModalAgain,
  selectAutoFillSupplierStockCodeEnabled,
  selectDontAskSupplierCodeAutoFillSession,
  selectPaginationDataForUserSelectedStore,
  selectDepAndSubDepForUserSelectedStore,
  selectClientFilteredStockItemsCacheForSelectedStore,
  selectIsClientFilteredStockPaginationActive,
  selectIsStockGridFilterLoading,
  selectStockDisableAudit,
  selectStockMangerVisibleFields,
  selectTypesenseQueryData,
} from './stock-manager.selectors';
import * as UserSelectors from '../../user-access/user-store/user.selectors';
import * as UserAccessSelectors from '../../user-access/user-store/user.selectors';
import {selectIsUserLoggedIn} from '../../user-access/user-store/user.selectors';
import * as UserStoreSelectors from '../../user-access/user-stores-store/user-store.selectors';
import {selectSelectedStore} from '../../user-access/user-stores-store/user-store.selectors';
import {IconsEnum} from '../../../shared-modules/shared-icons/models/icons.enum';
import * as NotificationActions from '../../notifications/store/notification.actions';
import {IGlobalError} from '../../../shared/shared-components/components/global-error-display/models/global-error';
import {editableFields} from '../models/stock-manager-editable-fields';
import {
  formatMultipleBarcodesForDisplay,
  stockManagerFieldValuesAreEqual,
} from '../utils/stock-manager-barcode.utils';
import {hasPriceOneChanged, stockManagerHasEditableFieldChanges} from '../utils/stock-manager-update.utils';
import {BULK_CHANGE_MAX_ITEMS} from '../models/stock-manager-bulk-change.model';
import {
  buildBulkStockUpdates,
  bulkChangeErrorMessage,
  chunkBulkStockUpdates,
  getCurrentGpBulkChangeExcludedItems,
} from '../utils/stock-manager-bulk-change.utils';
import {selectAppliedAdvancedFilterGroup} from '../../core/store-shared-filter/shared-filter.selectors';
import * as SharedFilterActions from '../../core/store-shared-filter/shared-filter.actions';
import {applyAdvancedFilterGroupToData} from '../../settings-new/models/general/advanced-filters.utils';
import {
  addOriginalValueFieldToItems,
  resolveClientFilteredStockItemsForSort,
  resolveStockManagerTypesenseSortField,
  yieldToLoop,
} from './stock-manager.reducer.utils';
import {ReportUtils} from '../../../shared-utilities/utils-old/shared-utils-old/report-utils';
import {ExportService} from '../../../shared/shared-services/dom/export-service.service';
import {createSharedPaths} from '../../../shared/shared-services/database-paths.shared';
import {
  selectUserAccess,
  selectUserAccessAdminForStores,
} from '../../user-access/user-access-store/user-access.selectors';
import {
  buildDisabledTagRuleUpdate,
  buildPartialDisableDescriptionUpdate,
  classifyStockDisableAudit,
  isDisableRuleConfigured,
  userCanProcessStockDisableAudit,
} from '../utils/stock-manager-disable-audit.utils';
import {IStore} from '../../../shared/shared-models/store/store';

import {
  findStockCodeForSupplier,
  isSupplierInMultipleSuppliers,
  normalizeSupplierDetails,
} from '../utils/stock-manager-supplier-code-auto-fill.utils';
import {
  getDepartmentDisplayName,
  getSubDepartmentDisplayName,
} from '../../../shared/shared-utils/stock/department-display.utils';
import {setNavigation} from '../../user-access/user-stores-store/user-store.actions';
import {NavigationPageEnum} from '../../user-access/models/navigations.enums';
import {TLineColour} from '../../settings-new/models';
import {CollectionSharedStockService} from '../../../shared/shared-services/firebase/collection-shared-stock.service';
import {IModalDismissResult, ModalControllerService} from '../../../shared/shared-services/overlay/modal-controller.service';
import {
  StockManagerSupplierCodeAutoFillModalComponent,
} from '../components/stock-manager-supplier-code-auto-fill-modal/stock-manager-supplier-code-auto-fill-modal.component';
import {
  ISupplierCodeAutoFillModalResult,
  SupplierCodeAutoFillModalMode,
} from '../models/supplier-code-auto-fill.interface';

const STOCK_MANAGER_CLIENT_FILTER_MAX_PAGES = 150;
const STOCK_MANAGER_CLIENT_FILTER_PAGE_SIZE = 250;
const STOCK_DISABLE_AUDIT_MAX_PAGES = 150;

function transformTypesenseStockItemsForGrid(mappedStockItems: StockItem[], store: IStore): StockItem[] {
  return mappedStockItems.map((item: StockItem) => {
    const stockItem: StockItem = {
      ...item,
      storeId: store.storeId,
      store: store.name,
      isEdited: false,
      isError: false,
      multipleSuppliers: item.multipleSuppliers ?? [],
    };
    const updatedStockItem = calculateGPFromPrice(stockItem, store, 2);
    if (isNaN(updatedStockItem.nominalGP)) {
      updatedStockItem.nominalGP = 100;
    }
    return {
      ...stockItem,
      ...updatedStockItem,
    };
  });
}

/**
 * Store the stock row belongs to. Single-store rows fall back to the header store.
 */
function resolveStockItemStore(item: StockItem, fallback: IStore | undefined, stores: IStore[]): IStore | undefined {
  const storeId = item?.storeId || fallback?.storeId;
  if (!storeId) {
    return fallback;
  }
  return stores?.find((store: IStore) => store.storeId === storeId) ?? fallback;
}

@Injectable()
export class StockManagerEffects {

  // [Stock Manager][TypeSense] Get All Api Keys'
  getAllTypesenseApiKeysForStores$ = createEffect(() =>
    this.actions$.pipe(
      ofType(StockManagerActions.getAllTypesenseApiKeysForStores),
      withLatestFrom(
        this.store.pipe(select(UserStoreSelectors.selectAllUserStores)),
        this.store.pipe(select(UserStoreSelectors.selectCurrentNavigationPage)),
        this.store.pipe(select(UserAccessSelectors.selectUser)),
      ),
      mergeMap(([action, stores, page, user]) =>
        from(this.collectionStoresDocsService.getAllTypesenseApiKeysForStores(stores)).pipe(
          mergeMap((apiDocs: Record<string, ITypeSenseApiDoc>) => {
            if (page === 'auto-ordering') {
              return concat(
                of(StockManagerActions.getAllTypesenseApiKeysForStoresSuccess({apiDocs})),
                of(AutoOrderActions.getTypesenseFacetCounts()),
              );
            }
            return of(StockManagerActions.getAllTypesenseApiKeysForStoresSuccess({apiDocs}));
          }),
          catchError((error) =>
            of(StockManagerActions.getAllTypesenseApiKeysForStoresFailure({
              error: {
                ...error,
                action: JSON.stringify(action),
                actionType: action.type,
                originalError: error,
                storeIds: stores.map((s) => s.storeId),
                userId: user.id,
              },
            })),
          ),
        ),
      ),
    ),
  );


  // Load suppliers for a single arbitrary store (Add Stock Item multi-store selection).
  // Does not touch grid loading state or trigger a stock-items reload.
  getStoreSuppliers$ = createEffect(() =>
    this.actions$.pipe(
      ofType(StockManagerActions.getStoreSuppliers),
      withLatestFrom(this.store.pipe(select(UserAccessSelectors.selectUser))),
      mergeMap(([action, user]) =>
        from(this.firebaseService.getSuppliers(action.store.storeId)).pipe(
          map((rawSuppliers: Record<string, Supplier>) => {
            const suppliers = Object.keys(rawSuppliers || {}).reduce((acc, key) => {
              acc[key] = {name: rawSuppliers[key].name, value: false};
              return acc;
            }, {} as ISearchableFields);
            return StockManagerActions.getStoreSuppliersSuccess({store: action.store, suppliers});
          }),
          catchError((error) => of(StockManagerActions.getStoreSuppliersFailure({
            store: action.store,
            error: {
              ...error,
              action: JSON.stringify(action),
              actionType: action.type,
              originalError: error,
              storeIds: [action.store.storeId],
              userId: user.id,
            },
          }))),
        ),
      ),
    ),
  );

  // Load departments for a single arbitrary store (Add Stock Item multi-store selection).
  getStoreDepartments$ = createEffect(() =>
    this.actions$.pipe(
      ofType(StockManagerActions.getStoreDepartments),
      withLatestFrom(this.store.pipe(select(UserAccessSelectors.selectUser))),
      mergeMap(([action, user]) =>
        from(this.firebaseService.getDepartmentsByStore(action.store)).pipe(
          map((departments: IDepartment[]) =>
            StockManagerActions.getStoreDepartmentsSuccess({store: action.store, departments}),
          ),
          catchError((error) => of(StockManagerActions.getStoreDepartmentsFailure({
            store: action.store,
            error: {
              ...error,
              action: JSON.stringify(action),
              actionType: action.type,
              originalError: error,
              storeIds: [action.store.storeId],
              userId: user.id,
            },
          }))),
        ),
      ),
    ),
  );

  // Load line colours for a single arbitrary store (Add Stock Item multi-store selection).
  getStoreLineColours$ = createEffect(() =>
    this.actions$.pipe(
      ofType(StockManagerActions.getStoreLineColours),
      withLatestFrom(this.store.pipe(select(UserAccessSelectors.selectUser))),
      mergeMap(([action, user]) =>
        from(this.firebaseService.getStoreDataDoc('line_colours', action.store.storeId)).pipe(
          map((lineColours) => StockManagerActions.getStoreLineColoursSuccess({
            store: action.store,
            lineColours: lineColours as TLineColour,
          })),
          catchError((error) => of(StockManagerActions.getStoreLineColoursFailure({
            store: action.store,
            error: {
              ...error,
              action: JSON.stringify(action),
              actionType: action.type,
              originalError: error,
              storeIds: [action.store.storeId],
              userId: user.id,
            },
          }))),
        ),
      ),
    ),
  );

  // '[Stock Manager][Line Colour] Get Line Colours',
  getLineColours$ = createEffect(() =>
    this.actions$.pipe(
      ofType(StockManagerActions.getLineColours),
      withLatestFrom(
        this.store.pipe(select(UserStoreSelectors.selectSelectedStore)),
        this.store.pipe(select(StockManagerSelectors.selectTypesenseQueryData)),
        this.store.pipe(select(UserAccessSelectors.selectUser)),
      ),
      switchMap(([action, store, {paginationData}, user]) =>
        from(this.firebaseService.getStoreDataDoc(action.pageStoreDocument, store.storeId)).pipe(
          mergeMap((lineColours: TLineColour) => {
            return [
              StockManagerActions.getLineColoursSuccess({lineColours, selectedStore: store}),
              StockManagerActions.getAllStockItems({
                idField: paginationData?.searchedValue == null ? '' : paginationData.searchedValue,
                currentPage: 1,
                pageSize: paginationData?.pageSize == null ? 100 : paginationData?.pageSize,
              }),
            ];
          }),
          catchError((error) => {
            return of(StockManagerActions.getLineColoursFailure({
              error: {
                ...error,
                action: JSON.stringify(action),
                actionType: action.type,
                originalError: error,
                storeIds: [store.storeId],
                userId: user.id,
              },
              store,
            }));
          }),
        ),
      ),
    ),
  );

  // '[Stock Manager][Item Disabling] Get Stock Items Disabling Rules',
  getStockItemDisablingRules$ = createEffect(() =>
    this.actions$.pipe(
      ofType(StockManagerActions.getStockItemDisablingRules),
      withLatestFrom(
        this.store.pipe(select(StockManagerSelectors.selectTypesenseQueryData)),
        this.store.pipe(select(UserAccessSelectors.selectUser)),
      ),
      mergeMap(([action, queryData, user]) => {
        const store = action.store ?? queryData.store;
        if (!store?.storeId) {
          return EMPTY;
        }
        const disableRules$ = from(this.collectionStoresSettingsService.getDocument<IDisableStockItemRule>(
          path_stores_storeId_settings_disable_stock_item_rules(store.storeId),
        )).pipe(catchError(() => of(null as IDisableStockItemRule)));
        const enableRules$ = from(this.collectionStoresSettingsService.getDocument<IEnableStockItemRule>(
          path_stores_storeId_settings_enable_stock_item_rules(store.storeId),
        )).pipe(catchError(() => of(null as IEnableStockItemRule)));
        return forkJoin({rulesDoc: disableRules$, enableRules: enableRules$}).pipe(
          map(({rulesDoc, enableRules}) =>
            StockManagerActions.getStockItemDisablingRulesSuccess({
              store,
              rulesDoc: normalizeDisableStockItemRuleFromFirestore(rulesDoc || undefined),
              enableRules: enableRules ?? undefined,
            }),
          ),
          catchError((error) =>
            of(StockManagerActions.getStockItemDisablingRulesFailure({
              error: {
                ...error,
                action: JSON.stringify(action),
                actionType: action.type,
                originalError: error,
                storeIds: [store.storeId],
                userId: user.id,
              },
            })),
          ),
        );
      }),
    ),
  );

  // =======================================================================
  // Stock Item
  // =======================================================================

  // '[Stock Manager][Stock Item] Get All Stock Items',
  getAllStockItems$ = createEffect(() =>
    this.actions$.pipe(
      ofType(StockManagerActions.getAllStockItems),
      withLatestFrom(this.store.pipe(select(StockManagerSelectors.selectTypesenseQueryData))),
      mergeMap(([{idField, currentPage, pageSize}, queryData]) => {
        const {
          store,
          searchableFields,
          sortType,
          filters,
          advancedFilterGroup,
          paginationData,
          suppliers,
        } = queryData;
        if (suppliers && Object.keys(suppliers)?.length > 0) {
          return of(
            StockManagerActions.getEditedItemsWithValueFromLocalStorage(),
            StockManagerActions.getAllStockItemsWithExistingSuppliers({
              idField,
              currentPage,
              pageSize: pageSize ?? 100,
              store,
              selectedFields: searchableFields,
              selectedStoreSuppliers: suppliers,
            }),
            StockManagerActions.getNextPageForStockItems(),
          );
        } else {
          return of(
            StockManagerActions.getEditedItemsWithValueFromLocalStorage(),
            StockManagerActions.getAllStockItemsWithoutExistingSuppliers({
              idField,
              currentPage,
              pageSize: pageSize ?? 100,
              store,
              selectedFields: searchableFields,
            }),
            StockManagerActions.getNextPageForStockItems(),
          );
        }
      }),
    ),
  );

  // [Stock Manager][Stock Item] Get All Stock Items When Suppliers Exist
  getAllStockItemsWithExistingSuppliers$ = createEffect(() =>
    this.actions$.pipe(
      ofType(StockManagerActions.getAllStockItemsWithExistingSuppliers),
      withLatestFrom(
        this.store.pipe(select(StockManagerSelectors.selectTypesenseQueryData)),
        this.store.pipe(select(UserAccessSelectors.selectUser)),
      ),
      switchMap(([action, queryData, user]) => {
        const {sortType, filters, advancedFilterGroup} = queryData;
        const {idField, currentPage, pageSize, store, selectedFields} = action;
        return this.typeSenseService
          .searchStockItems(
            idField,
            currentPage,
            pageSize ?? 100,
            store,
            selectedFields,
            filters,
            sortType,
            advancedFilterGroup,
          )
          .pipe(
            mergeMap((stockItemsRaw: TypeSenseSearchResponse<StockItem>) => {
              const facetCounts: IFacetCounts = createFacetCountsMap(stockItemsRaw.facet_counts);
              const paginationData: IPaginationData = {
                totalItems: stockItemsRaw.found,
                pageSize: pageSize ?? 100,
                currentPage,
                searchedValue: idField,
              };
              const mappedStockItems = mapTypeSenseObjectToGeneric<StockItem>(stockItemsRaw);
              let stockItems: StockItem[] = mappedStockItems.map((item: StockItem) => ({
                ...item,
                storeId: store.storeId,
                store: store.name,
                disabled: false,
                isEdited: false,
                isError: false,
                multipleSuppliers: item.multipleSuppliers ?? [],
              }));
              stockItems = stockItems.map((item: StockItem) => {
                const updatedStockItem = calculateGPFromPrice(item, store, 2);
                if (isNaN(updatedStockItem.nominalGP) || updatedStockItem.nominalGP === null) {
                  updatedStockItem.nominalGP = 100;
                }
                return updatedStockItem;
              });
              return [
                StockManagerActions.getAllStockItemsSuccess({
                  stockItems,
                  store,
                  paginationData,
                  facetCounts,
                }),
                StockManagerActions.getNextPageForStockItems(),
              ];
            }),
            catchError((error) =>
              of(StockManagerActions.getAllStockItemsFailure({
                  error: {
                    ...error,
                    action: JSON.stringify(action),
                    actionType: action.type,
                    originalError: error,
                    storeIds: [store.storeId],
                    userId: user.id,
                  },
                  store,
                },
              )),
            ),
          );
      }),
    ),
  );

  // [Stock Manager][Stock Item] Get All Stock Items When Suppliers Do Not Exist
  getAllStockItemsWithoutExistingSuppliers$ = createEffect(() =>
    this.actions$.pipe(
      ofType(StockManagerActions.getAllStockItemsWithoutExistingSuppliers),
      withLatestFrom(
        this.store.pipe(select(StockManagerSelectors.selectTypesenseQueryData)),
        this.store.pipe(select(UserAccessSelectors.selectUser)),
      ),
      switchMap(([action, queryData, user]) => {
        const {sortType, filters, advancedFilterGroup} = queryData;
        const {idField, currentPage, pageSize, store, selectedFields} = action;

        return this.typeSenseService
          .searchStockItems(idField, currentPage, pageSize ?? 100, store, selectedFields, filters, sortType, advancedFilterGroup)
          .pipe(
            mergeMap((stockItemsRaw) =>
              from(this.firebaseService.getSuppliers(store.storeId)).pipe(
                map((rawSuppliers: Record<string, Supplier>) => {
                  const suppliers = createMapFromObjectsObject<Supplier>(rawSuppliers, 'name');
                  const facetCounts: IFacetCounts = createFacetCountsMap(stockItemsRaw.facet_counts);
                  const manipulatedSuppliers = Object.keys(suppliers).reduce((acc, key) => {
                    acc[key] = {
                      name: rawSuppliers[key].name,
                      value: false,
                    };
                    return acc;
                  }, {} as ISearchableFields);

                  const paginationData: IPaginationData = {
                    totalItems: stockItemsRaw.found,
                    pageSize: pageSize ?? 100,
                    currentPage,
                    searchedValue: idField,
                  };

                  const mappedStockItems = mapTypeSenseObjectToGeneric<StockItem>(stockItemsRaw);
                  let stockItems = mappedStockItems.map((item: StockItem): StockItem => ({
                    ...item,
                    storeId: store.storeId,
                    store: store.name,
                    isEdited: false,
                    isError: false,
                    multipleSuppliers: item.multipleSuppliers ?? [],
                  }));
                  stockItems = stockItems.map((item: StockItem) => {
                    const updatedStockItem = calculateGPFromPrice(item, store, 2);
                    if (isNaN(updatedStockItem.nominalGP)) {
                      updatedStockItem.nominalGP = 100;
                    }
                    return {
                      ...item,
                      ...updatedStockItem,
                    };
                  });

                  return [
                    StockManagerActions.getSuppliersForStockManagerSuccess({
                      suppliers: manipulatedSuppliers,
                      store,
                    }),
                    StockManagerActions.getAllStockItemsSuccess({
                      stockItems,
                      store,
                      paginationData,
                      facetCounts,
                    }),
                    StockManagerActions.getNextPageForStockItems(),
                  ];
                }),
              ),
            ),
            mergeMap((actions) => from(actions)),
            catchError((error) =>
              from([
                StockManagerActions.getAllStockItemsFailure({
                  error: {
                    ...error,
                    action: JSON.stringify(action),
                    actionType: action.type,
                    originalError: error,
                    storeIds: [store.storeId],
                    userId: user.id,
                  },
                  store,
                }),
                StockManagerActions.getSuppliersForStockManagerFailure({
                  error: {
                    ...error,
                    action: JSON.stringify(action),
                    actionType: action.type,
                    originalError: error,
                    storeIds: [store.storeId],
                    userId: user.id,
                  },
                  store,
                }),
              ]),
            ),
          );
      }),
    ),
  );

  // =======================================================================
  // Departments and SubDepartments
  // =======================================================================

  // [Stock Manager][Departments] Get Store Departments For Stock Manager
  fetchStoreDepartments$ = createEffect(() =>
    this.actions$.pipe(
      ofType(StockManagerActions.getStoreDepartmentsForStockManager),
      withLatestFrom(
        this.store.pipe(select(StockManagerSelectors.selectTypesenseQueryData)),
        this.store.pipe(select(UserAccessSelectors.selectUser)),
      ),
      switchMap(([action, queryData, user]) => {
        const {store} = queryData;
        return this.firebaseService.getDepartmentsByStore(store).pipe(
          switchMap((departments: IDepartment[]) =>
            from(
              this.collectionSharedSingularDocumentsService.getDocument(
                createSharedPaths().setStoreId(store.storeId).storeSettings(),
              ),
            ).pipe(
              map((storeSettings: ISharedStoreSettings) =>
                StockManagerActions.getStoreDepartmentsForStockManagerSuccess({
                  store,
                  departments,
                  storeSettings,
                }),
              ),
              catchError((error) =>
                of(StockManagerActions.getStoreDepartmentsForStockManagerFailure({
                  error: {
                    ...error,
                    action: JSON.stringify(action),
                    actionType: action.type,
                    originalError: error,
                    storeIds: [store.storeId],
                    userId: user.id,
                  },
                  store,
                })),
              ),
            ),
          ),
          catchError((error) =>
            of(StockManagerActions.getStoreDepartmentsForStockManagerFailure({
              error: {
                ...error,
                action: JSON.stringify(action),
                actionType: action.type,
                originalError: error,
                storeIds: [store.storeId],
                userId: user.id,
              },
              store,
            })),
          ),
        );
      }),
    ),
  );


  // =======================================================================
  // Suppliers
  // =======================================================================

  // [Stock Manager][Suppliers] Set Suppliers For Stock Manager
  setSuppliers$ = createEffect(() =>
    this.actions$.pipe(
      ofType(StockManagerActions.setSuppliersForStockManager),
      withLatestFrom(this.store.pipe(
          select(StockManagerSelectors.selectTypesenseQueryData)),
        this.store.pipe(select(UserAccessSelectors.selectUser)),
      ),
      mergeMap(([action, queryData, user]) => {
        const {suppliers} = action;
        const {
          store,
          paginationData: {pageSize, searchedValue, currentPage},
          searchableFields,
          sortType,
          filters,
          advancedFilterGroup,
        } = queryData;

        return this.typeSenseService
          .searchStockItems(
            searchedValue,
            currentPage,
            pageSize ?? 100,
            store,
            searchableFields,
            filters,
            sortType,
            advancedFilterGroup,
          )
          .pipe(
            map((stockItemsRaw: TypeSenseSearchResponse<StockItem>) => {
              const paginationData: IPaginationData = {
                totalItems: stockItemsRaw.found,
                pageSize: pageSize ?? 100,
                currentPage,
                searchedValue,
              };
              const facetCounts: IFacetCounts = createFacetCountsMap(stockItemsRaw.facet_counts);
              const mappedStockItems = mapTypeSenseObjectToGeneric<StockItem>(stockItemsRaw);
              let stockItems: StockItem[] = mappedStockItems.map((item: StockItem) => ({
                ...item,
                storeId: store.storeId,
                store: store.name,
                isEdited: false,
                isError: false,
                multipleSuppliers: item.multipleSuppliers ?? [],
              }));
              stockItems = stockItems.map((item: StockItem) => {
                const updatedStockItem = calculateGPFromPrice(item, store, 2);
                if (isNaN(updatedStockItem.nominalGP)) {
                  updatedStockItem.nominalGP = 100;
                }
                return {
                  ...item,
                  ...updatedStockItem,
                };
              });
              return StockManagerActions.setSuppliersForStockManagerSuccess({
                stockItems,
                store,
                paginationData,
                facetCounts,
                suppliers,
              });
            }),
            catchError((error) =>
              of(StockManagerActions.getPaginationResultsForStockItemsFailure({
                error: {
                  ...error,
                  action: JSON.stringify(action),
                  actionType: action.type,
                  originalError: error,
                  storeIds: [store.storeId],
                  userId: user.id,
                },
                store,
              })),
            ),
          );
      }),
    ),
  );
  // <><><><><><><><><><><><><><><><><><><><><><><><><><><><><><><><><><><><><><><><><><><>


  // Filters and Menu Actions
  // <><><><><><><><><><><><><><><><><><><><><><><><><><><><><><><><><><><><><><><><><><><>

  // ====================================================================================================
  // Set Grid Menu Action
  // ====================================================================================================

  //[Stock Manager][Menu Actions] Set Stock Manager Menu Actions per Column
  setStockManagerMenuActionsWithStore$ = createEffect(() =>
    this.actions$.pipe(
      ofType(StockManagerActions.setStockManagerMenuActions),
      withLatestFrom(
        this.store.pipe(select(StockManagerSelectors.selectTypesenseQueryData)),
        this.store.pipe(select(StockManagerSelectors.selectEnablePriceBandingForStockManager)),
        this.store.pipe(select(StockManagerSelectors.selectIsStockManagerMultiStoreTab)),
      ),
      switchMap(([action, queryData, currentlyPriceBanding, isMultiStoreTab]) => {
        const store = isMultiStoreTab ? MULTI_STORE_SYNTHETIC_STORE : queryData.store;
        let sortType = '';

        if (action.gridHeaderMenu.typeOfChange === 'isSorting') {
          if (action.gridHeaderMenu.colId === 'depName' || action.gridHeaderMenu.colId === 'subDepName') {
            return EMPTY;
          }
          if (action.gridHeaderMenu.colId === 'store') {
            return of(StockManagerActions.setStockManagerMenuActionsWithStore({
              ...action,
              store,
            }));
          }
          const typesenseField = resolveStockManagerTypesenseSortField(action.gridHeaderMenu.colId);
          switch (action.gridHeaderMenu.sort) {
            case 'sort-asc':
              sortType = typesenseField ? `${typesenseField}:asc` : '';
              break;
            case 'sort-desc':
              sortType = typesenseField ? `${typesenseField}:desc` : '';
              break;
            default:
              sortType = ``;
              break;
          }
        }

        if (action.gridHeaderMenu.typeOfChange === 'isSorting') {
          const actions = [
            StockManagerActions.setStockManagerMenuActionsWithStore({
              ...action,
              store,
            }),
            StockManagerActions.setStockManagerSortTye({sortType}),
          ];
          return from(actions);
        } else if (action.gridHeaderMenu.typeOfChange === 'isPriceBanding') {
          let actions = [];
          if (action.gridHeaderMenu.value === currentlyPriceBanding) {
            actions = [
              StockManagerActions.setStockManagerMenuActionsWithStore({
                ...action,
                store: store,
              }),
            ];
          } else {
            actions = [
              StockManagerActions.setStockManagerMenuActionsWithStore({
                ...action,
                store: store,
              }),
              StockManagerActions.togglePriceBanding(),
            ];
          }

          return from(actions);
        } else {
          return of(
            StockManagerActions.setStockManagerMenuActionsWithStore({
              ...action,
              store,
            }),
          );
        }
      }),
    ),
  );

  // [Stock Manager][Menu Actions] Set Stock Manager Sort Type
  getAllStockItemsSorted$ = createEffect(() =>
    this.actions$.pipe(
      ofType(StockManagerActions.setStockManagerSortTye),
      withLatestFrom(
        this.store.pipe(select(StockManagerSelectors.selectTypesenseQueryData)),
        this.store.pipe(select(UserAccessSelectors.selectUser)),
        this.store.pipe(select(StockManagerSelectors.selectClientFilteredStockItemsCacheForSelectedStore)),
        this.store.pipe(select(StockManagerSelectors.selectSortingMenuEntry)),
        this.store.pipe(select(StockManagerSelectors.selectFacetCountsForUserSelectedStore)),
        this.store.pipe(select(StockManagerSelectors.selectIsStockManagerMultiStoreTab)),
        this.store.pipe(select(StockManagerSelectors.selectMultiStorePaginationData)),
      ),
      mergeMap(([
        action,
        queryData,
        user,
        clientFilteredStockItemsCache,
        sortingEntry,
        facetCounts,
        isMultiStoreTab,
        multiStorePagination,
      ]) => {
        if (isMultiStoreTab) {
          return of(StockManagerActions.getMultiStoreStockItems({
            currentPage: 1,
            pageSize: multiStorePagination.pageSize ?? 100,
            searchedValue: multiStorePagination.searchedValue ?? '',
          }));
        }

        const {sortType} = action;
        const {
          store,
          paginationData: {searchedValue, pageSize},
          searchableFields,
          filters,
          advancedFilterGroup,
        } = queryData;

        const useClientSideStringPresence = hasStringPresenceAdvancedFilters(advancedFilterGroup);
        if (useClientSideStringPresence) {
          const displayItems = resolveClientFilteredStockItemsForSort(
            clientFilteredStockItemsCache,
            sortingEntry,
          );
          const resolvedPageSize = pageSize ?? 100;
          return of(StockManagerActions.setStockItemFiltersSuccess({
            stockItems: displayItems,
            store,
            paginationData: {
              totalItems: displayItems.length,
              pageSize: resolvedPageSize,
              currentPage: 1,
              searchedValue,
            },
            facetCounts: facetCounts ?? {},
            filters,
            clientFilteredStockItemsCache,
          }));
        }

        return this.typeSenseService
          .searchStockItems(
            searchedValue,
            1,
            pageSize ?? 100,
            store,
            searchableFields,
            filters,
            sortType,
            advancedFilterGroup,
          )
          .pipe(
            map((stockItemsRaw: TypeSenseSearchResponse<StockItem>) => {
              const nextFacetCounts: IFacetCounts = createFacetCountsMap(stockItemsRaw.facet_counts);
              const paginationData: IPaginationData = {
                totalItems: stockItemsRaw.found,
                pageSize: pageSize ?? 100,
                currentPage: 1,
                searchedValue,
              };
              const mappedStockItems = mapTypeSenseObjectToGeneric<StockItem>(stockItemsRaw);
              let stockItems: StockItem[] = mappedStockItems.map((item: StockItem) => ({
                ...item,
                storeId: store.storeId,
                store: store.name,
                isEdited: false,
                isError: false,
                multipleSuppliers: item.multipleSuppliers ?? [],
              }));
              stockItems = stockItems.map((item: StockItem) => {
                const updatedStockItem = calculateGPFromPrice(item, store, 2);
                if (isNaN(updatedStockItem.nominalGP)) {
                  updatedStockItem.nominalGP = 100;
                }
                return {
                  ...item,
                  ...updatedStockItem,
                };
              });
              return StockManagerActions.getAllStockItemsSuccess({
                stockItems,
                store,
                paginationData,
                facetCounts: nextFacetCounts,
              });
            }),
            catchError((error) =>
              of(StockManagerActions.getAllStockItemsFailure({
                error: {
                  ...error,
                  action: JSON.stringify(action),
                  actionType: action.type,
                  originalError: error,
                  storeIds: [store.storeId],
                  userId: user.id,
                },
                store,
              })),
            ),
          );
      }),
    ),
  );

  // =======================================================================
  // Filters
  // =======================================================================

// '[Stock Manager][Filters] Set Stock Item Filters',
  setFilters$ = createEffect(() =>
    this.actions$.pipe(
      ofType(
        StockManagerActions.setStockItemFilters,
        SharedFilterActions.applyAdvancedFilterGroupFilterToGrid,
        SharedFilterActions.removeAdvancedFilterGroupFilterFromGrid,
      ),
      concatLatestFrom(() => [
        this.store.pipe(select(selectTypesenseQueryData)),
        this.store.pipe(select(UserAccessSelectors.selectUser)),
        this.store.pipe(select(StockManagerSelectors.selectIsStockManagerMultiStoreTab)),
        this.store.pipe(select(StockManagerSelectors.selectMultiStorePaginationData)),
      ]),
      switchMap(([action, queryData, user, isMultiStoreTab, multiStorePagination]) => {
        if (isMultiStoreTab) {
          if (action.type === StockManagerActions.setStockItemFilters.type) {
            return of(StockManagerActions.setMultiStoreStockItemFilters({
              filters: action.filters || {},
            }));
          }
          return of(StockManagerActions.getMultiStoreStockItems({
            currentPage: 1,
            pageSize: multiStorePagination.pageSize ?? 100,
            searchedValue: multiStorePagination.searchedValue ?? '',
          }));
        }

        const filters = action.type === StockManagerActions.setStockItemFilters.type
          ? (action).filters
          : queryData.filters;
        const {
          store,
          paginationData: {pageSize, searchedValue, currentPage: existingPage},
          searchableFields,
          sortType,
          advancedFilterGroup,
        } = queryData;
        const resolvedPageSize = pageSize ?? 100;
        const preserveCurrentPage: boolean = action.type === StockManagerActions.setStockItemFilters.type
          && action.preserveCurrentPage === true;
        const requestedPage: number = preserveCurrentPage ? (existingPage ?? 1) : 1;
        const useClientSideStringPresence = hasStringPresenceAdvancedFilters(advancedFilterGroup);
        const advancedFilterOptions = useClientSideStringPresence ? {omitStringPresence: true} : undefined;

        const buildSuccessAction = (
          stockItems: StockItem[],
          totalItems: number,
          facetCounts: IFacetCounts,
          clientFilteredStockItemsCache?: StockItem[],
        ): ReturnType<typeof StockManagerActions.setStockItemFiltersSuccess> => {
          const pageCount: number = totalItems > 0 ? Math.ceil(totalItems / resolvedPageSize) : 1;
          const currentPage: number = Math.min(Math.max(1, requestedPage), pageCount);
          return StockManagerActions.setStockItemFiltersSuccess({
            stockItems,
            store,
            paginationData: {
              totalItems,
              pageSize: resolvedPageSize,
              currentPage,
              searchedValue,
            },
            facetCounts,
            filters,
            clientFilteredStockItemsCache,
          });
        };

        const handleSearchError = (error: unknown): Observable<ReturnType<typeof StockManagerActions.setStockItemFiltersFailure>> =>
          of(StockManagerActions.setStockItemFiltersFailure({
            error: {
              ...(error as IGlobalError),
              action: JSON.stringify(action),
              actionType: action.type,
              originalError: error,
              storeIds: [store.storeId],
              userId: user.id,
            },
            store,
          }));

        const clearStaleClientFilterCache = of(
          StockManagerActions.clearClientFilteredStockItemsCache({storeId: store.storeId}),
        );

        if (useClientSideStringPresence && advancedFilterGroup) {
          const fetchPageSize = STOCK_MANAGER_CLIENT_FILTER_PAGE_SIZE;
          const fetchAllPages = (
            page = 1,
            filteredAcc: StockItem[] = [],
            unfilteredFetchedCount = 0,
            facetCounts: IFacetCounts = {},
          ): Observable<ReturnType<typeof StockManagerActions.setStockItemFiltersSuccess>> =>
            this.typeSenseService
              .searchStockItems(
                searchedValue,
                page,
                fetchPageSize,
                store,
                searchableFields,
                filters,
                sortType,
                advancedFilterGroup,
                advancedFilterOptions,
              )
              .pipe(
                mergeMap((stockItemsRaw: TypeSenseSearchResponse<StockItem>) =>
                  yieldToLoop(() => {
                    const mappedStockItems = mapTypeSenseObjectToGeneric<StockItem>(stockItemsRaw);
                    const stockItems = transformTypesenseStockItemsForGrid(mappedStockItems, store);
                    const pageFacetCounts = createFacetCountsMap(stockItemsRaw.facet_counts);
                    return {
                      stockItems,
                      total: stockItemsRaw.found,
                      facetCounts: page === 1 ? pageFacetCounts : facetCounts,
                    };
                  }),
                ),
                mergeMap(({stockItems, total, facetCounts: resolvedFacetCounts}) => {
                  const filteredChunk = applyAdvancedFilterGroupToData(stockItems, advancedFilterGroup);
                  const nextFiltered = [...filteredAcc, ...filteredChunk];
                  const nextUnfilteredCount = unfilteredFetchedCount + stockItems.length;
                  if (page >= STOCK_MANAGER_CLIENT_FILTER_MAX_PAGES || nextUnfilteredCount >= total) {
                    return of(buildSuccessAction(
                      nextFiltered,
                      nextFiltered.length,
                      resolvedFacetCounts,
                      nextFiltered,
                    ));
                  }
                  return fetchAllPages(page + 1, nextFiltered, nextUnfilteredCount, resolvedFacetCounts);
                }),
              );

          return concat(
            clearStaleClientFilterCache,
            of(StockManagerActions.setStockItemClientFilterLoading({loading: true})),
            fetchAllPages().pipe(catchError(handleSearchError)),
          );
        }

        return concat(
          clearStaleClientFilterCache,
          this.typeSenseService
          .searchStockItems(
            searchedValue,
            1,
            resolvedPageSize,
            store,
            searchableFields,
            filters,
            sortType,
            advancedFilterGroup ?? undefined,
            advancedFilterOptions,
          )
          .pipe(
            map((stockItemsRaw: TypeSenseSearchResponse<StockItem>) => {
              const facetCounts: IFacetCounts = createFacetCountsMap(stockItemsRaw.facet_counts);
              const mappedStockItems = mapTypeSenseObjectToGeneric<StockItem>(stockItemsRaw);
              const stockItems = transformTypesenseStockItemsForGrid(mappedStockItems, store);
              return buildSuccessAction(stockItems, stockItemsRaw.found, facetCounts);
            }),
            catchError(handleSearchError),
          ),
        );
      }),
    ),
  );
  // <><><><><><><><><><><><><><><><><><><><><><><><><><><><><><><><><><><><><><><><><><><>


  // Editing Items Functions
  // <><><><><><><><><><><><><><><><><><><><><><><><><><><><><><><><><><><><><><><><><><><>

  // [Stock Manager] set Edited Item
  setEditedItems$ = createEffect(() =>
    this.actions$.pipe(
      ofType(
        StockManagerActions.setEditedItem,
      ),
      withLatestFrom(
        this.store.pipe(select(UserStoreSelectors.selectSelectedStore)),
        this.store.pipe(select(UserStoreSelectors.selectAllUserStores)),
        this.store.pipe(select(StockManagerSelectors.selectStockManagerState)),
        this.store.pipe(select(StockManagerSelectors.selectEnablePriceBandingForStockManager)),
        this.store.pipe(select(selectPriceBandingForAllStores)),
        this.store.pipe(select(selectAllSharedGridVatRates)),
        this.store.pipe(select(selectFeatureStockRulesSettings)),
      ),
      // concatMap: do not drop rapid successive edits (e.g. supplier change then auto-fill suppCode)
      concatMap(([
        {stockItem},
        currentSelectedStore,
        allUserStores,
        stockManagerState,
        isPriceBanding,
        priceBandsPerStore,
        vatRatesPerStore,
        stockRules,
      ]) => {
        const targetStoreId = stockItem.storeId || currentSelectedStore?.storeId;
        const targetStore: IStore =
          allUserStores?.find((store: IStore) => store.storeId === targetStoreId)
          ?? (targetStoreId === currentSelectedStore?.storeId ? currentSelectedStore : null)
          ?? currentSelectedStore;

        if (!targetStore?.storeId) {
          return from([]);
        }

        const editedItemsForStore = stockManagerState.editedItems?.[targetStore.storeId] || {};
        const itemCode = String(stockItem.code ?? '');
        const existingEditedItem = editedItemsForStore?.[itemCode] ?? editedItemsForStore?.[stockItem.code];
        let updatedStockItem = {
          ...(existingEditedItem ?? {}),
          ...stockItem,
          code: itemCode || stockItem.code,
          storeId: targetStore.storeId,
          store: stockItem.store || targetStore.name,
        };
        delete updatedStockItem.disabled;

        const priceBands: IPriceBand[] = priceBandsPerStore?.[targetStore.storeId] || [];
        const vatRate: VatRates = vatRatesPerStore?.[targetStore.storeId] || {};
        const multiplePriceRules =
          stockRules?.multiplePriceChangeRules?.[targetStore.storeId]
          ?? createDefaultMultiplePriceChangeSettings();

        const priceOneChanged = hasPriceOneChanged(updatedStockItem);
        const existingHadPriceOneChange = !!existingEditedItem && hasPriceOneChanged(existingEditedItem);

        // Reverting price 1 leaves prices 2-10 on the earlier derived values. Put those back
        // before the dirty check so a full revert can clear the row instead of saving them.
        if (
          !priceOneChanged
          && existingHadPriceOneChange
          && hasActiveMultiplePriceChangeRules(multiplePriceRules)
        ) {
          updatedStockItem = restoreMultiplePriceChangeFieldsToOriginal(updatedStockItem);
        }

        const anyValueDiffers = stockManagerHasEditableFieldChanges(updatedStockItem);

        if (anyValueDiffers) {
          updatedStockItem.isEdited = true;

          if (isPriceBanding) {
            updatedStockItem = applyPriceBanding(
              updatedStockItem,
              priceBands,
              PRICE_BANDING_COLUMNS_FOR_NGP_REPORTS,
              targetStore,
              vatRate,
            );
          }

          // Prices 2-10 are derived from retail price 1, so they only recalculate when a driver of
          // price 1 (or its GP) changed. Editing an unrelated field must never touch the other prices.
          if (hasPriceOneChanged(updatedStockItem) && hasActiveMultiplePriceChangeRules(multiplePriceRules)) {
            updatedStockItem = applyMultiplePriceChangesToStockItem(
              updatedStockItem,
              multiplePriceRules,
              vatRate,
              priceBands,
            ).item;
          }

          return [
            StockManagerActions.setEditedItemAdd({
              stockItem: {...updatedStockItem},
              store: targetStore,
            }), StockManagerActions.setEditedItemToLocalStorage({
              stockItem: {...updatedStockItem},
              store: targetStore,
            }),
          ];
        } else if (editedItemsForStore?.[itemCode] || editedItemsForStore?.[stockItem.code]) {
          updatedStockItem.isEdited = false;

          return [
            StockManagerActions.setEditedItemRemove({
              stockItem: {...updatedStockItem},
              store: targetStore,
            }),
            StockManagerActions.setEditedItemToLocalStorage({
              stockItem: {...updatedStockItem},
              store: targetStore,
            }),
          ];
        } else {
          return from([]);
        }
      }),
      filter(action => !!action),
    ),
  );

  setEditedItemToLocalStorage$ = createEffect(() =>
    this.actions$.pipe(
      ofType(StockManagerActions.setEditedItemToLocalStorage),
      withLatestFrom(
        this.store.pipe(select(StockManagerSelectors.selectStockManagerState)),
        this.store.pipe(select(UserAccessSelectors.selectUser)),
      ),
      switchMap(([action, stockManagerState, user]) => {
        const store = action.store;
        try {
          const editedItems = stockManagerState.editedItems?.[store.storeId] || {};
          const storageKey = 'savedStockManagerEdits';
          const serializedData = localStorage.getItem(storageKey);
          let data: Record<string, unknown> = {};
          if (serializedData) {
            data = JSON.parse(serializedData);
          }
          data[store.storeId] = editedItems;
          localStorage.setItem(storageKey, JSON.stringify(data));
          return EMPTY;
        } catch (error) {
          return of(
            NotificationActions.setGlobalErrorOccurrence({
              error: {
                ...error,
                action: JSON.stringify(action),
                actionType: action.type,
                originalError: error,
                storeIds: [store?.storeId],
                userId: user.id,
              },
            }),
          );
        }
      }),
    ),
  );

  getEditedItemsWithValueFromLocalStorage$ = createEffect(() =>
    this.actions$.pipe(
      ofType(StockManagerActions.getEditedItemsWithValueFromLocalStorage),
      withLatestFrom(
        this.store.pipe(select(UserStoreSelectors.selectSelectedStore)),
        this.store.pipe(select(UserAccessSelectors.selectUser)),
      ),
      mergeMap(([action, store, user]) => {
        const storageKey = 'savedStockManagerEdits';
        try {
          const serializedData = localStorage.getItem(storageKey);
          if (serializedData !== null) {
            const data: Record<string, Record<string, StockItem>> = JSON.parse(serializedData);
            return of(
              StockManagerActions.setEditedItemsWithValueFromLocalStorage({
                editedItems: data,
                store,
              }),
            );
          }
          return EMPTY;
        } catch (error) {
          return of(
            AutoOrderActions.setRetryAutoOrderFailure({
              error: {
                ...error,
                action: JSON.stringify(action),
                actionType: action.type,
                originalError: error,
                storeIds: [store.storeId],
                userId: user.id,
              },
            }),
          );
        }
      }),
    ),
  );


  //[NGPReport] Clear Saved Edits For Store
  clearSavedNgpReportEditsForStore$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(StockManagerActions.removeEditedItemFromLocalStorage),
        withLatestFrom(this.store.pipe(select(UserStoreSelectors.selectSelectedStore))),
        tap(([_, store]) => {
          clearEditedItemsInLocalStorage(store, 'savedStockManagerEdits');
        }),
      ),
    {dispatch: false},
  );
  
  updateStockItemsWithEdited$ = createEffect(() =>
    this.actions$.pipe(
      ofType(
        StockManagerActions.getAllStockItemsSuccess,
        StockManagerActions.getPaginationResultsForStockItemsSuccess,
        StockManagerActions.getSearchResultsForStockItemsSuccess,
        StockManagerActions.setNextPageForSharedGridAtStoreId,
        StockManagerActions.setEditedItemsToStockPage,
        StockManagerActions.setBatchUpdateEditedItems,
        StockManagerActions.setStockItemFiltersSuccess,
        StockManagerActions.setEditedItemsWithValueFromLocalStorage,
      ),
      withLatestFrom(
        this.store.pipe(select(StockManagerSelectors.selectEditedItems)),
        this.store.pipe(select(StockManagerSelectors.selectTypesenseQueryData)),
        this.store.pipe(select(StockManagerSelectors.selectAllStockItemsForCurrentSelectedStore)),
      ),
      mergeMap(([_, editedItems, queryData, stockItems]) => {
        const {store} = queryData;
        let updatedStockItems: StockItem[] = [];

        // If stockItems haven't been loaded yet, skip the merge
        if (!stockItems || !Array.isArray(stockItems)) {
          return EMPTY;
        }

        if (editedItems && Object.keys(editedItems).length > 0) {
          const editedItemCodes = Object.keys(editedItems);
          updatedStockItems = stockItems.map((stockItem: StockItem) => {
            if (editedItemCodes.includes(stockItem.code)) {
              const mergedItem = {
                ...stockItem,
                ...editedItems[stockItem.code],
              };
              return {
                ...mergedItem,
                isEdited: stockManagerHasEditableFieldChanges(mergedItem),
              };
            }
            if (stockItem.isEdited) {
              return stockItem;
            }
            return {
              ...stockItem,
              isEdited: false,
            };
          });
        } else {
          updatedStockItems = stockItems?.map((stockItem: StockItem) => ({
            ...stockItem,
            isEdited: false,
          }));
        }

        return of(
          StockManagerActions.updateStockItemsWithEditedSuccess({
            stockItems: updatedStockItems,
            store,
            editedItems: editedItems ? Object.values(editedItems) : [],
          }),
        );
      }),
    ),
  );

  // =========================================
  // Item Disabling Rules
  // =========================================
  // [Stock Manager][Price] Set The Price, NGP for Stock Manager
  updatePriceGpForNgpReport$ = createEffect(() => this.actions$.pipe(
    ofType(StockManagerActions.setPriceGpForStockManager),
    withLatestFrom(
      this.store.pipe(select(UserStoreSelectors.selectSelectedStore))),
    switchMap(([action, currentSelectedStore]) => {
      const storeId = currentSelectedStore.storeId;
      const copiedStockItem: StockItem = {...action.stockItem};

      if (action.field === 'sellPriIncl1') {
        const obj = calculateGPFromPrice(copiedStockItem, currentSelectedStore, 2);
        copiedStockItem.nominalGP = obj.nominalGP;
      } else if (action.field === 'nominalGP') {
        if (copiedStockItem.nominalGP >= 100) {
          copiedStockItem.nominalGP = 99.99;
        }

        copiedStockItem.sellPriIncl1 = convertToDecimal(calculatePriceFromGpValue(currentSelectedStore, copiedStockItem), 2);
      }
      return [
        StockManagerActions.setPriceGpForStockMangerWithStoreID({
          stockItem: copiedStockItem,
          field: action.field,
          storeId: currentSelectedStore,
        }),
        StockManagerActions.setEditedItem({stockItem: copiedStockItem}),
      ];
    }),
  ));

  // ====================================================================================================
  // Multiple Price Change Rules
  // ====================================================================================================
  // [Stock Manager][Multiple Prices] Warn the user once per store that prices 2-10 follow price 1
  notifyMultiplePriceChangeRules$ = createEffect(() => this.actions$.pipe(
    ofType(StockManagerActions.setPriceGpForStockManager),
    withLatestFrom(
      this.store.pipe(select(UserStoreSelectors.selectSelectedStore)),
      this.store.pipe(select(selectSelectedStoreMultiplePriceChangeRules)),
      this.store.pipe(select(StockManagerSelectors.selectMultiplePriceChangeNoticeAcknowledgedStoreIds)),
    ),
    filter(([, currentSelectedStore, multiplePriceRules, acknowledgedStoreIds]) =>
      hasActiveMultiplePriceChangeRules(multiplePriceRules) &&
      !acknowledgedStoreIds.includes(currentSelectedStore?.storeId),
    ),
    map(([, currentSelectedStore]) => StockManagerActions.showMultiplePriceChangeNotice({store: currentSelectedStore})),
  ));

  // ====================================================================================================
  // Set Price And NGP For Stock Manager
  // ====================================================================================================
  // [Stock Manager][Preview Columns] Get Stock Manager Preview Columns'
  getStockManagerPreviewColumns$ = createEffect(() => {
      return this.actions$.pipe(
        ofType(StockManagerActions.getStockManagerPreviewColumns),
        withLatestFrom(
          this.store.pipe(select(UserStoreSelectors.selectSelectedStore)),
          this.store.pipe(select(UserAccessSelectors.selectUser)),
        ),
        switchMap(([action, store, user]) => {
          return from(this.collectionUsersSettingsService.getDocument<Record<number, string>>(
            path_users_userId_settings_stock_edits_preview(user.id)),
          ).pipe(
            map((columnData: Record<number, string>) =>
              StockManagerActions.setStockManagerPreviewColumnsSuccess({columnData: columnData ? columnData : {}}),
            ),
            catchError((error) => of(
              StockManagerActions.setStockManagerPreviewColumnsFailure({
                error: {
                  ...error,
                  action: JSON.stringify(action),
                  actionType: action.type,
                  originalError: error,
                  storeIds: [store.storeId],
                  userId: user.id,
                },
              })),
            ),
          );
        }),
      );
    },
  );

  // [Stock Manager][Update Firebase] Set Stock Updates On Firebase For Stock Manager
  setStockUpdatesForStockManger$ = createEffect(() =>
    this.actions$.pipe(
      ofType(
        StockManagerActions.setStockUpdatesForStockManger,
        StockManagerActions.setStockUpdatesForStore,
      ),
      withLatestFrom(
        this.store.pipe(select(UserStoreSelectors.selectSelectedStore)),
        this.store.pipe(select(UserAccessSelectors.selectUser)),
      ),
      mergeMap(([action, selectedStore, user]) => {
        const itemsToUpdate = action.itemsToUpdate;
        const isStoreSpecific = action.type === StockManagerActions.setStockUpdatesForStore.type;
        const store: IStore =
          ('store' in action && action.store)
            ? action.store
            : selectedStore;

        if (!store?.storeId || Object.keys(itemsToUpdate).length === 0) {
          if (isStoreSpecific) {
            return of(StockManagerActions.finishStockUpdateForStore({
              storeName: store?.name || 'Store',
              itemCount: 0,
              failed: true,
              message: 'No items were sent.',
            }));
          }
          return EMPTY;
        }

        return from(this.firebaseService.stockUpdate(store.storeId, itemsToUpdate)).pipe(
          mergeMap(() => {
            const itemCount = Object.keys(itemsToUpdate).length;
            if (!isStoreSpecific) {
              void this.sharedModalUtils.createModal({
                modalTitleIcon: IconsEnum.checkCircle,
                modalTitleIconColor: IconColourEnum.green,
                modalTitle: 'Stock update sent',
                contextDescription: [
                  `The entire batch of ${itemCount} item${itemCount === 1 ? '' : 's'} was written together.`,
                ],
                buttonAccept: false,
                buttonAcceptText: '',
                buttonClose: true,
                buttonCloseText: 'OK',
                buttonCloseCross: false,
                cssClass: ['shared-basic-modal-css-small'],
              });
            }
            const afterUpdateActions: Action[] = [
              StockManagerActions.removeEditedItemsAfterStockUpdate({store}),
              StockManagerActions.removeEditedItemFromLocalStorage(),
            ];
            if (isStoreSpecific) {
              afterUpdateActions.push(StockManagerActions.finishStockUpdateForStore({
                storeName: store.name,
                itemCount,
                failed: false,
              }));
            }
            return afterUpdateActions;
          }),
          catchError((error) => {
            const nestedError = error?.error;
            const globalError = {
              message: error?.message
                || nestedError?.message
                || 'Stock update was not sent. None of the items were written.',
              name: error?.name || nestedError?.name || 'StockUpdateError',
              action: JSON.stringify(action),
              actionType: action.type,
              originalError: error,
              storeIds: [store.storeId],
              userId: user.id,
            };
            const cancelled = globalError.message === 'Update Cancelled';
            if (!isStoreSpecific && !cancelled) {
              void this.sharedModalUtils.createModal({
                modalTitleIcon: IconsEnum.alertBox,
                modalTitleIconColor: IconColourEnum.red,
                modalTitle: 'Stock update failed',
                contextDescription: globalError.message.split('\n').filter((line: string) => line.length > 0),
                buttonAccept: false,
                buttonAcceptText: '',
                buttonClose: true,
                buttonCloseText: 'Close',
                buttonCloseCross: false,
                cssClass: ['shared-basic-modal-css-medium'],
              });
            }
            const failureActions: Action[] = [
              StockManagerActions.stockUpdateFailure({error: globalError}),
            ];
            if (isStoreSpecific) {
              failureActions.push(StockManagerActions.finishStockUpdateForStore({
                storeName: store.name,
                itemCount: 0,
                failed: true,
                message: cancelled ? 'Update cancelled.' : globalError.message,
              }));
            }
            return of(...failureActions);
          }),
        );
      }),
    ),
  );

  /**
   * After every selected store has been written, show one result and reload the multi-store grid once.
   */
  completeMultiStoreStockUpdates$ = createEffect(() =>
    this.actions$.pipe(
      ofType(StockManagerActions.finishStockUpdateForStore),
      withLatestFrom(
        this.store.pipe(select(StockManagerSelectors.selectStockUpdatesInFlight)),
        this.store.pipe(select(StockManagerSelectors.selectStockUpdateBatchResults)),
        this.store.pipe(select(StockManagerSelectors.selectMultiStorePaginationData)),
      ),
      filter(([, stockUpdatesInFlight]) => stockUpdatesInFlight === 0),
      tap(([, , results]) => {
        const anyFailed = results.some((result) => result.failed);
        const lines = results.map((result) => {
          if (result.failed) {
            return `${result.storeName}: ${result.message || 'Update failed.'}`;
          }
          const noun = result.itemCount === 1 ? 'item' : 'items';
          return `${result.storeName}: ${result.itemCount} ${noun} written.`;
        });
        void this.sharedModalUtils.createModal({
          modalTitleIcon: anyFailed ? IconsEnum.alertBox : IconsEnum.checkCircle,
          modalTitleIconColor: anyFailed ? IconColourEnum.red : IconColourEnum.green,
          modalTitle: anyFailed ? 'Stock update incomplete' : 'Stock update sent',
          contextDescription: lines,
          buttonAccept: false,
          buttonAcceptText: '',
          buttonClose: true,
          buttonCloseText: 'OK',
          buttonCloseCross: false,
          cssClass: ['shared-basic-modal-css-small'],
        });
      }),
      map(([, , , paginationData]) => StockManagerActions.getMultiStoreStockItems({
        currentPage: paginationData.currentPage ?? 1,
        pageSize: paginationData.pageSize ?? 100,
        searchedValue: paginationData.searchedValue ?? '',
      })),
    ),
  );

  removeEditedItemsAfterStockUpdate$ = createEffect(() =>
    this.actions$.pipe(
      ofType(StockManagerActions.removeEditedItemsAfterStockUpdate),
      withLatestFrom(
        this.store.pipe(select(StockManagerSelectors.selectPaginationDataForUserSelectedStore)),
        this.store.pipe(select(StockManagerSelectors.selectIsStockManagerMultiStoreTab)),
        this.store.pipe(select(StockManagerSelectors.selectMultiStorePaginationData)),
        this.store.pipe(select(StockManagerSelectors.selectStockUpdatesInFlight)),
      ),
      mergeMap(([_, paginationData, isMultiStoreTab, multiStorePagination, stockUpdatesInFlight]) => {
        if (isMultiStoreTab) {
          const actions: Action[] = [StockManagerActions.setEditedItemsToStockPage()];
          if (stockUpdatesInFlight === 0) {
            actions.unshift(StockManagerActions.getMultiStoreStockItems({
              currentPage: multiStorePagination.currentPage ?? 1,
              pageSize: multiStorePagination.pageSize ?? 100,
              searchedValue: multiStorePagination.searchedValue ?? '',
            }));
          }
          return actions;
        }
        return [
          StockManagerActions.getPaginationResultsForStockItems({
            pageNumber: paginationData.currentPage ?? 1,
          }),
          StockManagerActions.setEditedItemsToStockPage(),
        ];
      }),
    ),
  );
  exitStockManagerPreview$ = createEffect(() =>
    this.actions$.pipe(
      ofType(StockManagerActions.exitStockManagerPreview),
      withLatestFrom(
        this.store.pipe(select(StockManagerSelectors.selectPaginationDataForUserSelectedStore)),
      ),
      mergeMap(([_, paginationData]) => [
        StockManagerActions.getPaginationResultsForStockItems({
          pageNumber: paginationData.currentPage ?? 1,
        }),
        StockManagerActions.setEditedItemsToStockPage(),
      ]),
    ),
  );
  undoAllEditsToStockManager$ = createEffect(() =>
    this.actions$.pipe(
      ofType(StockManagerActions.undoAllEditsToStockManager),
      withLatestFrom(
        this.store.pipe(select(UserStoreSelectors.selectSelectedStore)),
        this.store.pipe(select(StockManagerSelectors.selectIsStockManagerMultiStoreTab)),
        this.store.pipe(select(StockManagerSelectors.selectMultiStoreSelectedStoreIds)),
        this.store.pipe(select(UserStoreSelectors.selectAllUserStores)),
      ),
      switchMap(([_, selectedStore, isMultiStoreTab, multiStoreIds, allStores]) => {
        if (isMultiStoreTab) {
          const stores = (multiStoreIds || [])
            .map((storeId: string) => allStores.find((store: IStore) => store.storeId === storeId))
            .filter((store: IStore | undefined): store is IStore => !!store);
          const actions: Action[] = stores.map((store: IStore) =>
            StockManagerActions.removeEditedItemsAfterStockUpdate({store}),
          );
          actions.push(StockManagerActions.removeEditedItemFromLocalStorage());
          return from(actions);
        }
        return from([
          StockManagerActions.removeEditedItemsAfterStockUpdate({store: selectedStore}),
          StockManagerActions.removeEditedItemFromLocalStorage(),
        ]);
      }),
    ),
  );
  // [Stock Manager][Pagination] Set Page Size For Shared Grid
  setPageSizeForSharedGrid$ = createEffect(() =>
    this.actions$.pipe(
      ofType(StockManagerActions.setPageSizeForSharedGrid),
      withLatestFrom(
        this.store.pipe(select(UserStoreSelectors.selectSelectedStore)),
        this.store.pipe(select(StockManagerSelectors.selectPaginationDataForUserSelectedStore)),
        this.store.pipe(select(StockManagerSelectors.selectIsStockManagerMultiStoreTab)),
        this.store.pipe(select(StockManagerSelectors.selectMultiStorePaginationData)),
      ),
      mergeMap(([{pageSize}, store, {currentPage}, isMultiStoreTab, multiStorePagination]) => {
        const resolvedPageSize = pageSize ?? 100;
        if (isMultiStoreTab) {
          return of(StockManagerActions.getMultiStoreStockItems({
            currentPage: 1,
            pageSize: resolvedPageSize,
            searchedValue: multiStorePagination.searchedValue ?? '',
          }));
        }
        return of(StockManagerActions.setPageSizeForSharedGridAtStoreId({
          pageSize: resolvedPageSize,
          store: store,
          pageNumber: currentPage,
        }));
      }),
    ),
  );
  // [Stock Manager][Pagination] Set Next Page For Shared Grid
  setNextPageForSharedGrid$ = createEffect(() =>
    this.actions$.pipe(
      ofType(StockManagerActions.setNextPageForSharedGrid),
      withLatestFrom(
        this.store.pipe(select(UserStoreSelectors.selectSelectedStore)),
        this.store.pipe(select(StockManagerSelectors.selectPaginationDataForUserSelectedStore)),
        this.store.pipe(select(UserStoreSelectors.selectCurrentNavigation)),
      ),
      mergeMap(([_, store, paginationData, {currentTab}]) => {
        if (currentTab !== 'preview') {
          const newPaginationData = getDeepCopyOfObject(paginationData);
          newPaginationData.currentPage++;
          return of(StockManagerActions.setNextPageForSharedGridAtStoreId({
            paginationData: newPaginationData,
            store,
          }));
        } else {
          return EMPTY;
        }
      }),
    ));
  // <><><><><><><><><><><><><><><><><><><><><><><><><><><><><><><><><><><><><><><><><><><>


  // Pagination and Search functions
  // <><><><><><><><><><><><><><><><><><><><><><><><><><><><><><><><><><><><><><><><><><><>
  // [Stock Manager][Pagination] Get Pagination Results For Stock Item [Grid]',
  getPaginationResults$ = createEffect(() =>
    this.actions$.pipe(
      ofType(StockManagerActions.getPaginationResultsForStockItems),
      withLatestFrom(
        this.store.pipe(select(StockManagerSelectors.selectTypesenseQueryData)),
        this.store.pipe(select(UserAccessSelectors.selectUser)),
        this.store.pipe(select(StockManagerSelectors.selectIsStockManagerMultiStoreTab)),
        this.store.pipe(select(StockManagerSelectors.selectMultiStorePaginationData)),
      ),
      mergeMap(([action, queryData, user, isMultiStoreTab, multiStorePagination]) => {
        const {pageNumber} = action;

        if (isMultiStoreTab) {
          return of(StockManagerActions.getMultiStoreStockItems({
            currentPage: pageNumber,
            pageSize: multiStorePagination.pageSize ?? 100,
            searchedValue: multiStorePagination.searchedValue ?? '',
          }));
        }

        const {
          store,
          paginationData: {pageSize, searchedValue},
          searchableFields,
          sortType,
          filters,
          advancedFilterGroup,
        } = queryData;
        const resolvedPageSize = pageSize ?? 100;
        const useClientSideStringPresence = hasStringPresenceAdvancedFilters(advancedFilterGroup);

        if (useClientSideStringPresence) {
          return of(StockManagerActions.setStockManagerPaginationCurrentPage({
            pageNumber,
            store,
          }));
        }

        return this.typeSenseService
          .searchStockItems(
            searchedValue,
            pageNumber,
            resolvedPageSize,
            store,
            searchableFields,
            filters,
            sortType,
            advancedFilterGroup,
          )
          .pipe(
            mergeMap((stockItemsRaw: TypeSenseSearchResponse<StockItem>) => {
              const paginationData: IPaginationData = {
                totalItems: stockItemsRaw.found,
                pageSize: resolvedPageSize,
                currentPage: pageNumber,
                searchedValue,
              };
              const resolvedFacetCounts: IFacetCounts = createFacetCountsMap(stockItemsRaw.facet_counts);
              const mappedStockItems = mapTypeSenseObjectToGeneric<StockItem>(stockItemsRaw);
              let stockItems: StockItem[] = mappedStockItems.map((item: StockItem) => ({
                ...item,
                storeId: store.storeId,
                store: store.name,
                isEdited: false,
                isError: false,
                multipleSuppliers: item.multipleSuppliers ?? [],
              }));
              stockItems = stockItems.map((item: StockItem) => {
                const updatedStockItem = calculateGPFromPrice(item, store, 2);
                if (isNaN(updatedStockItem.nominalGP)) {
                  updatedStockItem.nominalGP = 100;
                }
                return {
                  ...item,
                  ...updatedStockItem
                };
              });

              return [
                StockManagerActions.getPaginationResultsForStockItemsSuccess({
                  stockItems,
                  store,
                  paginationData,
                  facetCounts: resolvedFacetCounts,
                }),
                StockManagerActions.getNextPageForStockItems(),
              ];
            }),
            catchError((error) =>
              of(StockManagerActions.getPaginationResultsForStockItemsFailure({
                error: {
                  ...error,
                  action: JSON.stringify(action),
                  actionType: action.type,
                  originalError: error,
                  storeIds: [store.storeId],
                  userId: user.id,
                },
                store,
              })),
            ),
          );
      }),
    ),
  );
  // [Stock Manager][Pagination] Get Next Page For Stock Items',
  getNextPageForStockItems$ = createEffect(() =>
    this.actions$.pipe(
      ofType(StockManagerActions.getNextPageForStockItems),
      withLatestFrom(
        this.store.pipe(select(StockManagerSelectors.selectTypesenseQueryData)),
        this.store.pipe(select(UserAccessSelectors.selectUser)),
      ),
      filter(([_, queryData]) => !!queryData?.store && !!queryData?.paginationData && !!queryData?.searchableFields),
      mergeMap(([action, queryData, user]) => {
        const {
          store,
          searchableFields,
          sortType,
          paginationData: {currentPage, searchedValue, totalItems},
          filters,
          advancedFilterGroup,
        } = queryData;


        let {paginationData: {pageSize}} = queryData;

        if (!pageSize) {
          pageSize = 100;
        }

        const nextPageNumber = currentPage + 1 < totalItems / pageSize ? currentPage + 1 : 1;
        const useClientSideStringPresence = hasStringPresenceAdvancedFilters(advancedFilterGroup);

        if (useClientSideStringPresence) {
          return EMPTY;
        }

        return this.typeSenseService
          .searchStockItems(
            searchedValue,
            nextPageNumber,
            pageSize,
            store,
            searchableFields,
            filters,
            sortType,
            advancedFilterGroup,
          )
          .pipe(
            map((nextPageItems: TypeSenseSearchResponse<StockItem>) => {
              const mappedNextPageItems = mapTypeSenseObjectToGeneric<StockItem>(nextPageItems).map((item) => ({
                ...item,
                storeId: store.storeId,
                store: store.name,
              }));
              mappedNextPageItems.forEach((item: StockItem) => {
                const stockItem = calculateGPFromPrice(item, store, 2);
                item.disabled = false;
                item.nominalGP = +stockItem.nominalGP;
              });
              const nextPaginationData: IPaginationData = {
                totalItems: nextPageItems.found,
                pageSize,
                currentPage: currentPage,
                searchedValue,
              };
              return StockManagerActions.getNextPageForStockItemsSuccess({
                stockItems: mappedNextPageItems,
                store,
                nextPaginationData,
              });
            }),
            catchError((error) =>
              of(StockManagerActions.getNextPageForStockItemsFailure({
                error: {
                  ...error,
                  action: JSON.stringify(action),
                  actionType: action.type,
                  originalError: error,
                  storeIds: [store.storeId],
                  userId: user.id,
                },
                store,
              })),
            ),
          );
      }),
    ),
  );
  // [Stock Manager][Search Results] Get Search Results For Stock Items',
  getSearchResultsForStockItems$ = createEffect(() =>
    this.actions$.pipe(
      ofType(StockManagerActions.getSearchResultsForStockItems),
      withLatestFrom(
        this.store.pipe(select(StockManagerSelectors.selectTypesenseQueryData)),
        this.store.pipe(select(UserStoreSelectors.selectStores)),
        this.store.pipe(select(UserAccessSelectors.selectUser)),
      ),
      mergeMap(([action, queryData, stores, user]) => {
        const {idField} = action;
        const {
          store,
          paginationData: {pageSize},
          searchableFields,
          sortType,
          filters,
          advancedFilterGroup,
        } = queryData;

        return this.typeSenseService
          .searchStockItems(
            idField,
            1,
            pageSize ?? 100,
            store,
            searchableFields,
            filters,
            sortType,
            advancedFilterGroup,
          )
          .pipe(
            map((stockItemsRaw: TypeSenseSearchResponse<StockItem>) => {
              const paginationData: IPaginationData = {
                totalItems: stockItemsRaw.found,
                pageSize: pageSize ?? 100,
                currentPage: 1,
                searchedValue: idField,
              };
              const mappedStockItems = mapTypeSenseObjectToGeneric<StockItem>(stockItemsRaw);
              let stockItems: StockItem[] = mappedStockItems.map((item: StockItem) => ({
                ...item,
                storeId: store.storeId,
                store: store.name,
                isEdited: false,
                isError: false,
                multipleSuppliers: item.multipleSuppliers ?? [],
              }));
              stockItems = stockItems.map((item: StockItem) => {
                const updatedStockItem = calculateGPFromPrice(item, store, 2);
                if (isNaN(updatedStockItem.nominalGP)) {
                  updatedStockItem.nominalGP = 100;
                }
                return {...item, ...updatedStockItem } as StockItem;
              });
              return [
                StockManagerActions.getSearchResultsForStockItemsSuccess({
                  stockItems,
                  store,
                  paginationData,
                  facetCounts: createFacetCountsMap(stockItemsRaw.facet_counts),
                  stores,
                }),
                StockManagerActions.getNextPageForStockItems(),
              ];
            }),
            mergeMap((actions) => from(actions)),
            catchError((error) =>
              of(StockManagerActions.getSearchResultsForStockItemsFailure({
                error: {
                  ...error,
                  action: JSON.stringify(action),
                  actionType: action.type,
                  originalError: error,
                  storeIds: [store.storeId],
                  userId: user.id,
                },
                store,
              })),
            ),
          );
      }),
    ),
  );

  refreshStockData$ = createEffect(() =>
    this.actions$.pipe(
      ofType(StockManagerActions.refreshStockData),
      withLatestFrom(
        this.store.pipe(select(StockManagerSelectors.selectTypesenseQueryData)),
      ),
      map(([_, queryData]) => {
        if (hasStringPresenceAdvancedFilters(queryData.advancedFilterGroup)) {
          return StockManagerActions.setStockItemFilters({
            filters: queryData.filters,
            preserveCurrentPage: true,
          });
        }

        return StockManagerActions.getAllStockItems({
          idField: queryData.paginationData?.searchedValue ?? '',
          currentPage: queryData.paginationData?.currentPage ?? 1,
          pageSize: queryData.paginationData?.pageSize ?? 100,
        });
      }),
    ),
  );
  protected readonly iconColourEnum = IconColourEnum;

  // =======================================================================
  // Search Results
  // =======================================================================
  private readonly icons = IconsEnum;
  // [Stock Manager][Edited Items] Get Edited Items from Typesense
  getEditedItemsFromTypesense$ = createEffect(() =>
    this.actions$.pipe(
      ofType(StockManagerActions.getEditedItemsFromTypesense),
      withLatestFrom(
        this.store.pipe(select(StockManagerSelectors.selectTypesenseQueryData)),
        this.store.pipe(select(StockManagerSelectors.selectEditedItems)),
        this.store.pipe(select(selectPriceBandingForUserSelectedStore)),
        this.store.pipe(select(selectSharedGridVatRateBySelectedStore)),
        this.store.pipe(select(StockManagerSelectors.selectEnablePriceBandingForStockManager)),
        this.store.pipe(select(UserAccessSelectors.selectUser)),
      ),
      mergeMap(([action, queryData, editedItems, priceBanding, vatRates, isPriceBanding, user]) => {
        const {
          store,
          paginationData: {searchedValue},
          searchableFields,
        } = queryData;
        const maxPageLimit = 150;
        const fetchAllPages = (
          currentPage = 1,
          combinedHits: StockItem[] = [],
        ): Observable<{ hits: StockItem[]; facetCounts: IFacetCounts | null }> => {
          return this.typeSenseService
            .multiSearchEditedStockItems(
              searchedValue,
              currentPage,
              store,
              searchableFields,
              editedItems,
              200,
            )
            .pipe(
              mergeMap((stockItemsRaw: TypeSenseSearchResponse<StockItem>) => {
                const newHits = stockItemsRaw.hits.map((document: TypeSenseHit<StockItem>) => Object.values(document)[0] as unknown as StockItem);
                const allHits = [...combinedHits, ...newHits];
                const facetCounts = createFacetCountsMap(stockItemsRaw.facet_counts || []);

                if (currentPage > maxPageLimit) {
                  return of({hits: allHits, facetCounts});
                }

                if (allHits.length < stockItemsRaw.found) {
                  return fetchAllPages(currentPage + 1, allHits);
                } else {
                  return of({hits: allHits, facetCounts});
                }
              }),
            );
        };

        return fetchAllPages().pipe(
          mergeMap(({hits: allStockItems, facetCounts}) => {
            const mappedEditedStockItems = allStockItems.map((item: StockItem) => ({
              ...item,
              code: item.code,
              storeId: store.storeId,
              store: store.name,
              isEdited: true,
              isError: false,
            }));

            const discrepancies: {
              code: string;
              field: string;
              original: string | number | boolean | Date;
              current: string | number | boolean | Date;
            }[] = [];
            const omittedKeys = [
              'originalValue',
              'isSelected',
              'isEdited',
              '_tags',
              'multipleSuppliers',
              'supplierDetails',
              'nominalGP',
            ];

            mappedEditedStockItems.forEach((item: StockItem) => {
              const editedItem = editedItems[item.code];
              if (editedItem) {
                Object.keys(item).forEach((key: string) => {
                  const localOriginalValue = editedItem.originalValue[key]?.value;
                  const remoteValue = item[key];
                  if (
                    !omittedKeys.includes(key) &&
                    !stockManagerFieldValuesAreEqual(key, remoteValue, localOriginalValue) &&
                    sItemKeyToInt[key] &&
                    editableFields.includes(key)
                  ) {
                    const formatDiscrepancyValue = (
                      fieldKey: string,
                      value: string | number | boolean | Date,
                    ): string | number | boolean | Date => {
                      if (fieldKey === 'multipleBarcodes') {
                        return formatMultipleBarcodesForDisplay(value);
                      }
                      return value;
                    };
                    discrepancies.push({
                      code: item.code,
                      field: sItemKeyToInt[key],
                      original: formatDiscrepancyValue(key, localOriginalValue),
                      current: formatDiscrepancyValue(key, remoteValue),
                    });
                  }
                });
              }
            });

            if (discrepancies.length > 0) {
              const discrepancyMessages = discrepancies.map(
                (d: {
                  code: string;
                  field: string;
                  original: string | number | boolean | Date;
                  current: string | number | boolean | Date
                }) => {
                  const fieldKey = sItemIntToKey[d.field];
                  const fieldLabel = AO_KEY_2_TITLE[fieldKey] ?? PropertyToTitle[fieldKey] ?? fieldKey;
                  return `Item Code: ${d.code} | Field: ${fieldLabel} | Local: ${d.original} | Remote: ${d.current}`;
                },
              );
              const ModalProps = {
                buttonAccept: false,
                buttonAcceptText: '',
                buttonClose: true,
                buttonCloseCross: false,
                buttonCloseText: 'Continue',
                modalTitle: 'Discrepancies Found in Stock Items',
                modalTitleIcon: IconsEnum.infoSlabCircleOutline,
                modalTitleIconColor: IconColourEnum.red,
                contextHeading:
                  'Some stock items were updated by another source while you were editing them.',
                contextDescription: [
                  'Please review the discrepancies below:',
                  ...discrepancyMessages,
                ],
                cssClass: ['shared-basic-modal-css-larger'],
              };
              void this.sharedModalUtils.createModal(ModalProps);
            }

            const filterEditedItems = (
              allEdited: Record<string, StockItem>,
            ): Record<string, StockItem> => {
              const filteredItems: Record<string, StockItem> = {};

              for (const [key, stockItem] of Object.entries(allEdited)) {
                const hasDiff = Object.keys(stockItem).some((field: string) => {
                  const originalValue = stockItem.originalValue?.[field]?.value;
                  const currentValue = stockItem[field];
                  return !stockManagerFieldValuesAreEqual(field, currentValue, originalValue);
                });
                if (hasDiff) {
                  filteredItems[key] = stockItem;
                }
              }
              return filteredItems;
            };
            const filteredItems = Object.values(filterEditedItems(editedItems));
            return [
              StockManagerActions.getEditedItemsFromTypesenseSuccess({
                editedItemsFromTypesense: mappedEditedStockItems,
                store,
                facetCounts: facetCounts || {},
                priceBandedItems: isPriceBanding
                  ? applyPriceBanding(
                    Object.values(filterEditedItems(editedItems)),
                    priceBanding,
                    PRICE_BANDING_COLUMNS_FOR_NGP_REPORTS,
                    store,
                    vatRates,
                  )
                  : filteredItems,
              }),
            ];
          }),
          catchError((error) =>
            of(StockManagerActions.getEditedItemsFromTypesenseFailure({
              error: {
                ...error,
                action: JSON.stringify(action),
                actionType: action.type,
                originalError: error,
                storeIds: [store.storeId],
                userId: user.id,
              },
              store,
            })),
          ),
        );
      }),
    ),
  );

  // [Stock Manager][Price Banding] Toggle Price Banding
  // No dispatch needed: the reducer flips isPriceBanding and selectStockManagerPriceBanded
  // reactively applies/removes banding from the existing stockItems in the grid.
  togglePriceBanding$ = createEffect(() =>
    this.actions$.pipe(
      ofType(StockManagerActions.togglePriceBanding),
    ),
    {dispatch: false},
  );

  syncDisableRulesAfterSettingsSave$ = createEffect(() =>
    this.actions$.pipe(
      ofType(settingStockItemEnableRules.setDisableStockItemRuleSuccess),
      map(({settings, store}) =>
        StockManagerActions.getStockItemDisablingRulesSuccess({
          store,
          rulesDoc: normalizeDisableStockItemRuleFromFirestore(settings),
        }),
      ),
    ),
  );

  // [Stock Manager][Item Disabling] Set Item to be Disabled
  setItemDisabled$ = createEffect(() =>
    this.actions$.pipe(
      ofType(StockManagerActions.setItemDisabledStatus),
      withLatestFrom(
        this.store.pipe(select(StockManagerSelectors.selectTypesenseQueryData)),
        this.store.pipe(select(StockManagerSelectors.selectStockManagerState)),
        this.store.pipe(select(StockManagerSelectors.selectDontDisplayModalAgain)),
        this.store.pipe(select(UserStoreSelectors.selectAllUserStores)),
      ),
      switchMap(([action, queryData, stockManagerState, dontDisplayModalAgain, allStores]) => {
        const stockItem = structuredClone(action.stockItem);
        const enable = action.enable;
        const store = resolveStockItemStore(stockItem, queryData.store, allStores);
        const disabledRules = store ? stockManagerState.disabledRules?.[store.storeId] : undefined;
        const enabledRules = store ? stockManagerState.enabledRules?.[store.storeId] : undefined;

        if (disabledRules) {
          stockItem.disabled = !enable;
          if (!enable) {
            if (!stockItem._tags?.includes('disabled')) {
              stockItem._tags = [...(stockItem._tags ?? []), 'disabled'];
            }
          } else {
            stockItem._tags = (stockItem._tags ?? []).filter((tag: string) => tag !== 'disabled');
          }

          const normalizedDisableRules = normalizeDisableStockItemRuleFromFirestore(disabledRules);
          ReportUtils.enableReport(
            stockItem,
            normalizedDisableRules,
            enabledRules ?? ({} as IEnableStockItemRule),
            enable,
          );
        } else if (!dontDisplayModalAgain) {
          const ModalProps: ISharedModalBasic = {
            buttonAccept: false,
            buttonAcceptText: '',
            buttonClose: true,
            buttonCloseCross: false,
            buttonCloseText: 'Continue',
            modalTitle: `No Item Disabling Rules Found`,
            modalTitleIcon: this.icons.infoSlabCircleOutline,
            modalTitleIconColor: this.iconColourEnum.red,
            contextHeading: `This Item Will Only Be ${!action.enable ? 'Disabled' : 'Enabled'} On Gallix`,
            contextDescription: [
              'No changes will take place on IQ.',
              'If you wish for changes to be made on IQ please complete the Stock Item Disabling settings.',
            ],
            cssClass: ['shared-basic-modal-css-medium'],
          };
          return from(this.sharedModalUtils.createModal(ModalProps)).pipe(
            mergeMap((result: IModalDismissResult<ISharedModalBasicResponse>) => {
              return [StockManagerActions.setItemDisabledWithStoreID({
                stockItem,
                store,
              }), StockManagerActions.setDontDisplayModalAgain()];
            }),
          );
        }
        return [StockManagerActions.setEditedItem({stockItem})];
      }),
    ),
  );


  setBatchItemDisabled$ = createEffect(() =>
    this.actions$.pipe(
      ofType(StockManagerActions.setItemsDisabledStatusBatch),
      withLatestFrom(
        this.store.select(selectTypesenseQueryData),
        this.store.select(StockManagerSelectors.selectStockManagerState),
        this.store.select(selectDontDisplayModalAgain),
        this.store.pipe(select(UserSelectors.selectIsUserLoggedIn)),
        this.store.pipe(select(UserStoreSelectors.selectAllUserStores)),
      ),
      switchMap(([{
        items,
        enable,
      }, queryData, stockManagerState, dontDisplay, isUserLoggedIn, allStores]) => {
        if (!isUserLoggedIn) {
          return EMPTY;
        }
        const fallbackStore = queryData.store;
        const merged = items.map((item: StockItem) => {
          const itemStoreId = item.storeId || fallbackStore?.storeId;
          const priorEdit: StockItem = stockManagerState.editedItems?.[itemStoreId]?.[String(item.code)]
            ?? stockManagerState.editedItems?.[itemStoreId]?.[item.code];
          if (!priorEdit) {
            return item;
          }
          return {
            ...priorEdit,
            originalValue: priorEdit.originalValue,
          } as StockItem;
        });

        merged.forEach((item: StockItem) => {
          item.disabled = !enable;
          if (!enable) {
            if (!item._tags?.includes('disabled')) {
              item._tags = [...(item._tags ?? []), 'disabled'];
            }
          } else if (item._tags?.includes('disabled')) {
            item._tags = item._tags.filter((tag: string) => tag !== 'disabled');
          }
        });

        const itemsByStore = new Map<string, StockItem[]>();
        merged.forEach((item: StockItem) => {
          const itemStore = resolveStockItemStore(item, fallbackStore, allStores);
          const storeId = itemStore?.storeId;
          if (!storeId) {
            return;
          }
          const group = itemsByStore.get(storeId) ?? [];
          group.push(item);
          itemsByStore.set(storeId, group);
        });

        let missingRules = false;
        itemsByStore.forEach((storeItems: StockItem[], storeId: string) => {
          const storeRules = stockManagerState.disabledRules?.[storeId];
          if (!storeRules) {
            missingRules = true;
            return;
          }
          const normalizedDisableRules = normalizeDisableStockItemRuleFromFirestore(storeRules);
          const storeEnableRules = stockManagerState.enabledRules?.[storeId] ?? ({} as IEnableStockItemRule);
          storeItems.forEach((item: StockItem) =>
            ReportUtils.enableReport(item, normalizedDisableRules, storeEnableRules, enable),
          );
        });

        const batchActions: Action[] = [];
        itemsByStore.forEach((storeItems: StockItem[], storeId: string) => {
          const store = allStores.find((userStore: IStore) => userStore.storeId === storeId) ?? fallbackStore;
          if (!store) {
            return;
          }
          batchActions.push(StockManagerActions.setBatchUpdateEditedItems({
            batchUpdateEditedItems: storeItems,
            store,
          }));
        });

        if (missingRules && !dontDisplay) {
          const modalProps: ISharedModalBasic = {
            buttonAccept: false,
            buttonClose: true,
            buttonCloseText: 'Continue',
            modalTitle: 'No Item Disabling Rules Found',
            modalTitleIcon: this.icons.infoSlabCircleOutline,
            modalTitleIconColor: this.iconColourEnum.red,
            contextHeading: `This item will only be ${
              enable ? 'enabled' : 'disabled'
            } on Gallix`,
            contextDescription: [
              'No changes will take place on IQ.',
              'If you wish for changes to be made on IQ please complete the Stock Item Disabling settings.',
            ],
            cssClass: ['shared-basic-modal-css-medium'],
            buttonAcceptText: '',
            buttonCloseCross: false,
          };

          return from(this.sharedModalUtils.createModal(modalProps)).pipe(
            mergeMap(() => [
              ...batchActions,
              StockManagerActions.setDontDisplayModalAgain(),
            ]),
          );
        }

        return from(batchActions);
      }),
    ),
  );

  lockAllStockItems$ = createEffect(() =>
    this.actions$.pipe(
      ofType(StockManagerActions.lockAllStockItems),
      withLatestFrom(
        this.store.pipe(select(selectTypesenseQueryData)),
        this.store.pipe(select(selectAppliedAdvancedFilterGroup)),
        this.store.pipe(select(UserAccessSelectors.selectIsUserLoggedIn)),
        this.store.pipe(select(UserAccessSelectors.selectUser)),
      ),
      mergeMap(([action, queryData, advancedFilters, isUserLoggedIn, user]) => {
        if (!isUserLoggedIn) {
          return EMPTY;
        }
        const {
          store,
          paginationData: {searchedValue},
          searchableFields,
          filters,
        } = queryData;

        const maxPageLimit = 150;

        const fetchAllPages = (
          page = 1,
          acc: StockItem[] = [],
        ): Observable<StockItem[]> =>
          this.typeSenseService
            .searchFilteredStockItems(
              searchedValue,
              page,
              store,
              searchableFields,
              advancedFilters ? advancedFilters : null,
            )
            .pipe(
              mergeMap((response: TypeSenseSearchResponse<StockItem>) =>
                yieldToLoop(() => {
                  const mapped = mapTypeSenseObjectToGeneric<StockItem>(response);

                  const transformed = mapped.map((raw: StockItem) => {
                    const base: StockItem = {
                      ...raw,
                      storeId: store.storeId,
                      store: store.name,
                      disabled: true,
                      isEdited: false,
                      isError: false,
                      ['_tags']: [...raw._tags],
                      multipleSuppliers: raw.multipleSuppliers ?? [],
                    };

                    const priced = calculateGPFromPrice(base, store, 2);
                    if (isNaN(priced.nominalGP) || priced.nominalGP === null) {
                      priced.nominalGP = 100;
                    }
                    return priced;
                  });

                  return {chunk: transformed, total: response.found};
                }),
              ),
              mergeMap(({chunk, total}) => {
                const next = [...acc, ...chunk];
                return page > maxPageLimit || next.length >= total
                  ? of(next)
                  : fetchAllPages(page + 1, next);
              }),
            );
        return fetchAllPages().pipe(
          map((items: StockItem[]) => addOriginalValueFieldToItems<StockItem>(items)),
          concatMap(items =>
            of(
              StockManagerActions.setItemsDisabledStatusBatch({
                items,
                enable: action.enable,
              }),
            ),
          ),
          catchError((error) =>
            from([
                NotificationActions.setGlobalErrorOccurrence({
                  error: {
                    ...error,
                    action: JSON.stringify(action),
                    actionType: action.type,
                    originalError: error,
                    storeIds: [store.storeId],
                    userId: user.id,
                  },
                }),
                StockManagerActions.lockAllStockItemsFailure(),
              ],
            ),
          ),
        );
      }),
    ),
  );

  runStockDisableAudit$ = createEffect(() =>
    this.actions$.pipe(
      ofType(StockManagerActions.runStockDisableAudit),
      withLatestFrom(
        this.store.pipe(select(selectTypesenseQueryData)),
        this.store.pipe(select(StockManagerSelectors.selectStockManagerState)),
        this.store.pipe(select(selectIsUserLoggedIn)),
        this.store.pipe(select(UserAccessSelectors.selectUser)),
        this.store.pipe(select(selectUserAccess)),
      ),
      switchMap(([action, queryData, stockManagerState, isUserLoggedIn, user, userAccess]) => {
        if (!isUserLoggedIn) {
          return EMPTY;
        }
        const store = queryData.store;
        if (!store?.storeId) {
          return of(StockManagerActions.runStockDisableAuditFailure({
            errorMessage: 'Select a store before running the audit.',
          }));
        }
        if (!userCanProcessStockDisableAudit(userAccess?.stores?.[store.storeId])) {
          return of(StockManagerActions.runStockDisableAuditFailure({
            errorMessage: 'You do not have permission to update stock.',
          }));
        }

        const rules = normalizeDisableStockItemRuleFromFirestore(stockManagerState.disabledRules?.[store.storeId]);
        const enableRules = stockManagerState.enabledRules?.[store.storeId] ?? ({} as IEnableStockItemRule);
        const rulesConfigured = isDisableRuleConfigured(rules.onHandZero) || isDisableRuleConfigured(rules.onHandNotZero);
        if (!rulesConfigured) {
          return of(StockManagerActions.runStockDisableAuditSuccess({
            disabledRuleMismatches: [],
            missingDisableTag: [],
            partialDisableDescriptions: [],
            rulesConfigured: false,
            scannedCount: 0,
            truncated: false,
          }));
        }

        const searchableFields = Object.values(queryData.searchableFields ?? {}).some((field) => field?.value)
          ? queryData.searchableFields
          : {...DEFAULT_SEARCHABLE_FIELDS};

        const fetchAllPages = (
          page = 1,
          acc: StockItem[] = [],
        ): Observable<{found: number; items: StockItem[]; truncated: boolean}> =>
          this.typeSenseService
            .searchFilteredStockItems('*', page, store, searchableFields)
            .pipe(
              mergeMap((response: TypeSenseSearchResponse<StockItem>) =>
                yieldToLoop(() => {
                  const mapped = mapTypeSenseObjectToGeneric<StockItem>(response);
                  const chunk = mapped.map((raw: StockItem): StockItem => {
                    const priced = calculateGPFromPrice({
                      ...raw,
                      _tags: Array.isArray(raw._tags) ? [...raw._tags] : [],
                      isEdited: false,
                      isError: false,
                      multipleSuppliers: raw.multipleSuppliers ?? [],
                      store: store.name,
                      storeId: store.storeId,
                    }, store, 2);
                    if (isNaN(priced.nominalGP) || priced.nominalGP === null) {
                      priced.nominalGP = 100;
                    }
                    return priced;
                  });
                  return {chunk, total: response?.found ?? chunk.length};
                }),
              ),
              mergeMap(({chunk, total}) => {
                const next = [...acc, ...chunk];
                if (chunk.length === 0 || next.length >= total) {
                  return of({found: total, items: next, truncated: false});
                }
                if (page >= STOCK_DISABLE_AUDIT_MAX_PAGES) {
                  return of({found: total, items: next, truncated: true});
                }
                return fetchAllPages(page + 1, next);
              }),
            );

        return fetchAllPages().pipe(
          map(({found, items, truncated}) => {
            const classified = classifyStockDisableAudit(
              addOriginalValueFieldToItems<StockItem>(items),
              rules,
              enableRules,
            );
            return StockManagerActions.runStockDisableAuditSuccess({
              disabledRuleMismatches: classified.disabledRuleMismatches,
              missingDisableTag: classified.missingDisableTag,
              partialDisableDescriptions: classified.partialDisableDescriptions,
              rulesConfigured: true,
              scannedCount: truncated ? items.length : found,
              truncated,
            });
          }),
          catchError((error) =>
            of(
              NotificationActions.setGlobalErrorOccurrence({
                error: {
                  ...error,
                  action: JSON.stringify(action),
                  actionType: action.type,
                  originalError: error,
                  storeIds: [store.storeId],
                  userId: user?.id,
                },
              }),
              StockManagerActions.runStockDisableAuditFailure({
                errorMessage: 'The stock audit could not be completed. Try again.',
              }),
            ),
          ),
        );
      }),
    ),
  );

  /**
   * Clears the applied advanced filter when an audit list opens. The stock reload
   * that normally follows a filter change would replace that list.
   */
  clearFiltersForStockDisableAudit$ = createEffect(() =>
    this.actions$.pipe(
      ofType(StockManagerActions.showStockDisableAuditItems),
      map(() => SharedFilterActions.clearAppliedAdvancedFilterGroup()),
    ),
  );

  applyStockDisableAuditRuleMismatch$ = createEffect(() =>
    this.actions$.pipe(
      ofType(StockManagerActions.applyStockDisableAuditRuleMismatch),
      withLatestFrom(
        this.store.pipe(select(selectStockDisableAudit)),
        this.store.pipe(select(selectSelectedStore)),
        this.store.pipe(select(StockManagerSelectors.selectStockManagerState)),
        this.store.pipe(select(selectUserAccess)),
      ),
      switchMap(([, audit, store, stockManagerState, userAccess]) => {
        if (!store?.storeId || !userCanProcessStockDisableAudit(userAccess?.stores?.[store.storeId])) {
          return of(StockManagerActions.runStockDisableAuditFailure({
            errorMessage: 'You do not have permission to update stock.',
          }));
        }
        const rules = normalizeDisableStockItemRuleFromFirestore(stockManagerState.disabledRules?.[store.storeId]);
        const enableRules = stockManagerState.enabledRules?.[store.storeId] ?? ({} as IEnableStockItemRule);
        const updates = audit.disabledRuleMismatches
          .map((item: StockItem) => buildDisabledTagRuleUpdate(item, rules, enableRules))
          .filter((item: StockItem | null): item is StockItem => !!item);
        if (!updates.length) {
          return EMPTY;
        }
        const count = updates.length;
        return of(
          StockManagerActions.setBatchUpdateEditedItems({batchUpdateEditedItems: updates, store}),
          StockManagerActions.showStockDisableAuditItems({
            notice: `${count} disabled ${count === 1 ? 'item has' : 'items have'} the disable rule for their on-hand staged as edits. Review them, then submit.`,
            stockItems: updates,
            store,
          }),
        );
      }),
    ),
  );

  applyStockDisableAuditPartialDescription$ = createEffect(() =>
    this.actions$.pipe(
      ofType(StockManagerActions.applyStockDisableAuditPartialDescription),
      withLatestFrom(
        this.store.pipe(select(selectStockDisableAudit)),
        this.store.pipe(select(selectSelectedStore)),
        this.store.pipe(select(StockManagerSelectors.selectStockManagerState)),
        this.store.pipe(select(selectUserAccess)),
      ),
      switchMap(([, audit, store, stockManagerState, userAccess]) => {
        if (!store?.storeId || !userCanProcessStockDisableAudit(userAccess?.stores?.[store.storeId])) {
          return of(StockManagerActions.runStockDisableAuditFailure({
            errorMessage: 'You do not have permission to update stock.',
          }));
        }
        const rules = normalizeDisableStockItemRuleFromFirestore(stockManagerState.disabledRules?.[store.storeId]);
        const enableRules = stockManagerState.enabledRules?.[store.storeId] ?? ({} as IEnableStockItemRule);
        const updates = audit.partialDisableDescriptions
          .map((item: StockItem) => buildPartialDisableDescriptionUpdate(item, rules, enableRules))
          .filter((item: StockItem | null): item is StockItem => !!item);
        if (!updates.length) {
          return EMPTY;
        }
        const count = updates.length;
        return of(
          StockManagerActions.setBatchUpdateEditedItems({batchUpdateEditedItems: updates, store}),
          StockManagerActions.showStockDisableAuditItems({
            notice: `${count} ${count === 1 ? 'item has' : 'items have'} the rest of the disable rule staged as edits, without the disabled tag. Review them, then submit.`,
            stockItems: updates,
            store,
          }),
        );
      }),
    ),
  );

  applyStockDisableAuditMissingTag$ = createEffect(() =>
    this.actions$.pipe(
      ofType(StockManagerActions.applyStockDisableAuditMissingTag),
      withLatestFrom(
        this.store.pipe(select(selectStockDisableAudit)),
        this.store.pipe(select(selectSelectedStore)),
        this.store.pipe(select(selectUserAccess)),
      ),
      switchMap(([, audit, store, userAccess]) => {
        if (!store?.storeId || !userCanProcessStockDisableAudit(userAccess?.stores?.[store.storeId])) {
          return of(StockManagerActions.runStockDisableAuditFailure({
            errorMessage: 'You do not have permission to update stock.',
          }));
        }
        const items = audit.missingDisableTag;
        if (!items.length) {
          return EMPTY;
        }
        const count = items.length;
        return of(
          StockManagerActions.setItemsDisabledStatusBatch({enable: false, items}),
          StockManagerActions.showStockDisableAuditItems({
            notice: `${count} ${count === 1 ? 'item now has' : 'items now have'} the disabled tag staged as an edit. Review them, then submit.`,
            stockItems: items,
            store,
          }),
        );
      }),
    ),
  );

  downloadFilteredItemsAsCSV$ = createEffect(() =>
    this.actions$.pipe(
      ofType(StockManagerActions.downloadFilteredItemsAsCSV),
      withLatestFrom(
        this.store.pipe(select(selectTypesenseQueryData)),
        this.store.pipe(select(selectAppliedAdvancedFilterGroup)),
        this.store.pipe(select(selectIsUserLoggedIn)),
        this.store.pipe(select(selectStockMangerVisibleFields)),
        this.store.pipe(select(selectDepAndSubDepForUserSelectedStore)),
        this.store.pipe(select(UserAccessSelectors.selectUser)),
      ),
      mergeMap(([action, queryData, advancedFilters, isUserLoggedIn, visibleFields, departments, user]) => {
        if (!isUserLoggedIn) {
          return EMPTY;
        }
        const {
          store,
          paginationData: {searchedValue},
          searchableFields,
          filters,
        } = queryData;

        const maxPageLimit = 250;

        const fetchAllPages = (
          page = 1,
          acc: StockItem[] = [],
        ): Observable<StockItem[]> =>
          this.typeSenseService
            .searchFilteredStockItems(
              searchedValue,
              page,
              store,
              searchableFields,
              advancedFilters ? advancedFilters : null,
              filters,
            )
            .pipe(
              mergeMap((response: TypeSenseSearchResponse<StockItem>) =>
                yieldToLoop(() => {
                  const mapped = mapTypeSenseObjectToGeneric<StockItem>(response);

                  const transformed = mapped.map((raw: StockItem) => {
                    const base: StockItem = {
                      ...raw,
                      storeId: store.storeId,
                      store: store.name,
                      disabled: true,
                      isEdited: false,
                      isError: false,
                      ['_tags']: [...raw._tags],
                      multipleSuppliers: raw.multipleSuppliers ?? [],
                    };

                    const priced = calculateGPFromPrice(base, store, 2);
                    if (isNaN(priced.nominalGP) || priced.nominalGP === null) {
                      priced.nominalGP = 100;
                    }
                    return priced;
                  });

                  return {chunk: transformed, total: response.found};
                }),
              ),
              mergeMap(({chunk, total}) => {
                const next = [...acc, ...chunk];
                return page > maxPageLimit || next.length >= total
                  ? of(next)
                  : fetchAllPages(page + 1, next);
              }),
            );
        return fetchAllPages().pipe(
          map((items: StockItem[]) => addOriginalValueFieldToItems<StockItem>(items)),
          tap((items: StockItem[]) => {
            const colHeaders = Object.keys(visibleFields)
              .filter((field: string) => visibleFields[field] !== false && field !== 'icons');
            const exportRows: StockItem[] = items.map((item: StockItem): StockItem => ({
              ...item,
              unitsMonthAvg: Number(getMonthlyAverage(item)),
              depName: getDepartmentDisplayName(item.dep, departments),
              subDepName: getSubDepartmentDisplayName(item.subDep, departments),
            } as StockItem));
            this.exportService.exportStockItemDataAsCSV<StockItem>(exportRows, colHeaders, 'stock-items.csv');
          }),
          map(() =>
            StockManagerActions.downloadFilteredItemsAsCSVSuccess(),
          ),
          catchError((error) =>
            from([
                NotificationActions.setGlobalErrorOccurrence({
                  error: {
                    ...error,
                    action: JSON.stringify(action),
                    actionType: action.type,
                    originalError: error,
                    storeIds: [store.storeId],
                    userId: user.id,
                  },
                }),
                StockManagerActions.lockAllStockItemsFailure(),
              ],
            ),
          ),
        );
      }),
    ),
  );

  setBatchEditsToLocalStorage$ = createEffect(() =>
    this.actions$.pipe(
      ofType(StockManagerActions.setBatchUpdateEditedItems),
      withLatestFrom(
        this.store.pipe(select(selectSelectedStore)),
      ),
      map(([_, store]) => {
        return StockManagerActions.setEditedItemToLocalStorage({
          stockItem: {} as StockItem,
          store: store,
        });
      }),
    ),
  );

  createNewStockItem$ = createEffect(() =>
    this.actions$.pipe(
      ofType(StockManagerActions.createNewStockItem),
      concatLatestFrom(() => [
        this.store.pipe(select(UserStoreSelectors.selectSelectedStore)),
        this.store.pipe(select(UserAccessSelectors.selectUser)),
      ]),
      exhaustMap(([action, store, user]) => {
        const {newStockItem, storeIds, itemsByStore} = action;

        // Prefer per-store payloads when provided (e.g. each store has its own generated
        // stock code). Otherwise fall back to the shared payload + storeIds, defaulting to
        // the currently selected store when neither is supplied.
        const writes: [string, Record<string, StockItemUpdateObj>][] =
          itemsByStore && Object.keys(itemsByStore).length > 0
            ? Object.entries(itemsByStore)
            : (storeIds && storeIds.length > 0 ? storeIds : [store.storeId])
              .map((id: string): [string, Record<string, StockItemUpdateObj>] => [id, newStockItem]);

        // Fan out the write to every target store. Use allSettled so a single store's failure
        // doesn't abort the writes to the other stores and we can report per-store outcomes.
        return from(
          Promise.allSettled(
            writes.map(([storeId, items]: [string, Record<string, StockItemUpdateObj>]) =>
              this.firebaseService
                .stockUpdate(storeId, items, false, true)
                .then(() => storeId)
                .catch((error: unknown) => {
                  throw {storeId, error};
                }),
            ),
          ),
        ).pipe(
          mergeMap((results: PromiseSettledResult<string>[]) => {
            const succeededStoreIds = results
              .filter((r): r is PromiseFulfilledResult<string> => r.status === 'fulfilled')
              .map((r) => r.value);

            const failed = results
              .filter((r): r is PromiseRejectedResult => r.status === 'rejected')
              .map((r) => {
                const reason = r.reason as { storeId: string; error: { message?: string; name?: string } };
                return {
                  storeId: reason.storeId,
                  message: reason.error?.message,
                };
              });

            if (failed.length === 0) {
              return [StockManagerActions.createNewStockItemSuccess()];
            }

            const failedStoreIds = failed.map((f) => f.storeId);
            const firstFailure = failed[0];
            const globalError: IGlobalError = {
              message: firstFailure.message ?? `Failed to create stock item in ${failedStoreIds.length} store(s)`,
              name: 'CreateNewStockItemError',
              action: JSON.stringify(action),
              actionType: action.type,
              originalError: firstFailure,
              storeIds: failedStoreIds,
              userId: user.id,
            };

            return [
              StockManagerActions.createNewStockItemFailure({failed, succeededStoreIds}),
              NotificationActions.setGlobalErrorOccurrence({error: globalError}),
            ];
          }),
        );
      }),
    ),
  );

  navigateToStoreSetting$ = createEffect(() =>
    this.actions$.pipe(
      ofType(StockManagerActions.navigateToStoreSettings),
      withLatestFrom(
        this.store.select(UserStoreSelectors.selectSelectedStore),
        this.store.select(selectUserAccessAdminForStores),
      ),
      exhaustMap(([_, store, adminStores]) => {
        if (!store?.storeId || !adminStores?.includes(store.storeId)) return EMPTY;

        return of(
          setNavigation({
            feature: NavigationPageEnum.Settings,
            navigation: {currentPage: 'settings', currentTab: 'store'},
          }),
        );
      }),
    ),
  );


  // [Stock Manager][Supplier Code Auto Fill] Prompt to auto-fill suppCode when supplier changes to an other-supplier code
  checkSupplierCodeAutoFillOnSupplierChange$ = createEffect(() =>
    this.actions$.pipe(
      ofType(StockManagerActions.checkSupplierCodeAutoFillOnSupplierChange),
      withLatestFrom(
        this.store.pipe(select(selectAutoFillSupplierStockCodeEnabled)),
        this.store.pipe(select(selectDontAskSupplierCodeAutoFillSession)),
      ),
      filter(([, enabled, dontAskAgain]) => enabled && !dontAskAgain),
      exhaustMap(([action]) =>
        from(this.handleSupplierCodeAutoFillPrompt(action.stockItem, action.newSupplierCode)),
      ),
    ),
    {dispatch: false},
  );


applyBulkStockChanges$ = createEffect(() =>
    this.actions$.pipe(
      ofType(StockManagerActions.applyBulkStockChanges),
      withLatestFrom(
        this.store.pipe(select(selectTypesenseQueryData)),
        this.store.pipe(select(selectAppliedAdvancedFilterGroup)),
        this.store.pipe(select(selectIsUserLoggedIn)),
        this.store.pipe(select(UserAccessSelectors.selectUser)),
        this.store.pipe(select(selectSharedGridVatRateBySelectedStore)),
        this.store.pipe(select(selectPriceBandingForUserSelectedStore)),
      ),
      mergeMap(([
        action,
        queryData,
        advancedFilters,
        isUserLoggedIn,
        user,
        vatRates,
        priceBands,
      ]) => {
        const toFailure = (error: unknown, cancelled = false): Observable<Action> => {
          const globalError = {
            name: 'GlobalError',
            message: bulkChangeErrorMessage(error),
            action: JSON.stringify(action),
            actionType: action.type,
            originalError: error,
            storeIds: queryData?.store?.storeId ? [queryData.store.storeId] : [],
            userId: user?.id,
          } as IGlobalError;
          const actions: Action[] = [
            StockManagerActions.applyBulkStockChangesFailure({error: globalError, cancelled}),
          ];
          if (!cancelled) {
            actions.unshift(NotificationActions.setGlobalErrorOccurrence({error: globalError}));
          }
          return from(actions);
        };

        if (!isUserLoggedIn || !queryData?.store?.storeId) {
          return toFailure(new Error('You must be signed in with a store selected to apply bulk changes.'));
        }

        const store = queryData.store;
        return this.loadBulkChangeItems(queryData, advancedFilters, vatRates).pipe(
          mergeMap((items: StockItem[]) => {
            const updates = buildBulkStockUpdates(items, action.rows, store, vatRates, priceBands ?? []);
            const batches = chunkBulkStockUpdates(updates);
            if (batches.length === 0) {
              return of(StockManagerActions.applyBulkStockChangesSuccess());
            }
            const itemCount = Object.keys(updates).length;
            this.store.dispatch(StockManagerActions.setBulkChangeStatus({
              message: `Preparing ${itemCount} ${itemCount === 1 ? 'item' : 'items'} in ${batches.length} ${batches.length === 1 ? 'batch' : 'batches'}…`,
            }));
            let batchesSent = 0;
            return from(batches).pipe(
              concatMap((batch: Record<string, StockItemUpdateObj>, index: number) => {
                const batchCount = Object.keys(batch).length;
                this.store.dispatch(StockManagerActions.setBulkChangeStatus({
                  message: `Sending batch ${index + 1} of ${batches.length} (${batchCount} ${batchCount === 1 ? 'item' : 'items'}) and creating the processing message…`,
                }));
                return from(this.firebaseService.stockUpdate(store.storeId, batch, false)).pipe(
                  tap(() => {
                    batchesSent += 1;
                  }),
                );
              }),
              toArray(),
              mergeMap(() => from([
                StockManagerActions.applyBulkStockChangesSuccess(),
                StockManagerActions.refreshStockData(),
              ])),
              catchError((error: unknown) => {
                const message = bulkChangeErrorMessage(error);
                if (batchesSent > 0) {
                  return toFailure(
                    new Error(`${batchesSent} of ${batches.length} batches were sent before the update stopped. ${message}`),
                    message === 'Update Cancelled',
                  );
                }
                return toFailure(error, message === 'Update Cancelled');
              }),
            );
          }),
          catchError((error: unknown) => toFailure(error, bulkChangeErrorMessage(error) === 'Update Cancelled')),
        );
      }),
    ),
  );

  prepareBulkStockChanges$ = createEffect(() =>
    this.actions$.pipe(
      ofType(StockManagerActions.prepareBulkStockChanges),
      withLatestFrom(
        this.store.pipe(select(selectTypesenseQueryData)),
        this.store.pipe(select(selectAppliedAdvancedFilterGroup)),
        this.store.pipe(select(selectIsUserLoggedIn)),
        this.store.pipe(select(UserAccessSelectors.selectUser)),
        this.store.pipe(select(selectSharedGridVatRateBySelectedStore)),
      ),
      switchMap(([action, queryData, advancedFilters, isUserLoggedIn, user, vatRates]) => {
        const toFailure = (error: unknown): Observable<Action> => {
          const globalError = {
            name: 'GlobalError',
            message: bulkChangeErrorMessage(error),
            action: JSON.stringify(action),
            actionType: action.type,
            originalError: error,
            storeIds: queryData?.store?.storeId ? [queryData.store.storeId] : [],
            userId: user?.id,
          } as IGlobalError;
          return from([
            NotificationActions.setGlobalErrorOccurrence({error: globalError}),
            StockManagerActions.prepareBulkStockChangesFailure({error: globalError}),
          ]);
        };

        if (!isUserLoggedIn || !queryData?.store?.storeId) {
          return toFailure(new Error('You must be signed in with a store selected to apply bulk changes.'));
        }

        return this.loadBulkChangeItems(queryData, advancedFilters, vatRates).pipe(
          map((items: StockItem[]) => StockManagerActions.prepareBulkStockChangesSuccess({
            excludedItems: getCurrentGpBulkChangeExcludedItems(items, action.rows),
          })),
          catchError((error: unknown) => toFailure(error)),
        );
      }),
    ),
  );

  getMultiStoreStockItems$ = this.createGetMultiStoreStockItemsEffect();

// <><><><><><><><><><><><><><><><><><><><><><><><><><><><><><><><><><><><><><><><><><><>
  constructor(
    private actions$: Actions,
    private firebaseService: FirebaseService,
    private typeSenseService: TypeSenseService,
    private collectionUsersSettingsService: CollectionUsersSettingsService,
    private collectionSharedSingularDocumentsService: CollectionSharedSingularDocumentsService,
    private collectionStoresSettingsService: CollectionStoresSettingsService,
    private collectionStoresDocsService: CollectionStoresDocsService,
    private collectionSharedStockService: CollectionSharedStockService,
    private sharedModalUtils: SharedModalUtils,
    private exportService: ExportService,
    private modalController: ModalControllerService,
    private readonly store: Store,
  ) {
  }

  /**
   * Loads every item matched by the current filter for a bulk change, using the client-filter cache when it is active.
   * Errors when the filter is still loading or when 1,000 or more items match.
   */
  private loadBulkChangeItems(
    queryData: TypesenseQueryData,
    advancedFilters: IAdvancedFilterGroup | null,
    vatRates: VatRates,
  ): Observable<StockItem[]> {
    const store = queryData.store;
    const {
      paginationData: {searchedValue},
      searchableFields,
      filters,
      sortType,
    } = queryData;
    const omitStringPresence = hasStringPresenceAdvancedFilters(advancedFilters);
    const tooManyItems = (): Observable<never> =>
      throwError(() => new Error('Bulk changes are limited to fewer than 1,000 items.'));

    const mapPage = (rawItems: StockItem[]): StockItem[] =>
      rawItems.map((raw: StockItem) => {
        const base: StockItem = {
          ...raw,
          storeId: store.storeId,
          store: store.name,
          _tags: Array.isArray(raw._tags) ? [...raw._tags] : [],
          multipleSuppliers: raw.multipleSuppliers ?? [],
        };
        try {
          const priced = calculateGPFromPrice(base, store, 2, vatRates);
          if (!Number.isFinite(priced.nominalGP)) {
            priced.nominalGP = Number.isFinite(base.nominalGP) ? base.nominalGP : 0;
          }
          return priced;
        } catch {
          return base;
        }
      });

    const fetchAllPages = (page = 1, acc: StockItem[] = [], fetched = 0): Observable<StockItem[]> =>
      this.typeSenseService
        .searchStockItems(
          searchedValue,
          page,
          STOCK_MANAGER_CLIENT_FILTER_PAGE_SIZE,
          store,
          searchableFields,
          filters,
          sortType,
          advancedFilters ? advancedFilters : undefined,
          omitStringPresence ? {omitStringPresence: true} : undefined,
        )
        .pipe(
          mergeMap((response: TypeSenseSearchResponse<StockItem>) => {
            if (!omitStringPresence && (response?.found ?? 0) >= BULK_CHANGE_MAX_ITEMS) {
              return tooManyItems();
            }
            return yieldToLoop(() => {
              const mapped = mapTypeSenseObjectToGeneric<StockItem>(response);
              const matched = omitStringPresence
                ? applyAdvancedFilterGroupToData(mapped, advancedFilters)
                : mapped;
              return {chunk: mapPage(matched), pageSize: mapped.length, total: response.found ?? matched.length};
            });
          }),
          mergeMap(({chunk, pageSize, total}) => {
            const next = [...acc, ...chunk];
            const fetchedNext = fetched + pageSize;
            const loadedCount = Math.min(fetchedNext, total);
            this.store.dispatch(StockManagerActions.setBulkChangeStatus({
              message: `Loaded ${loadedCount} of ${total} matching items…`,
            }));
            if (next.length >= BULK_CHANGE_MAX_ITEMS) {
              return tooManyItems();
            }
            const scannedAll = pageSize === 0 || fetchedNext >= total;
            if (scannedAll) {
              return of(next);
            }
            if (page >= STOCK_MANAGER_CLIENT_FILTER_MAX_PAGES) {
              return throwError(() => new Error(
                'Not all matching items could be loaded. Narrow the filter and try again.',
              ));
            }
            return fetchAllPages(page + 1, next, fetchedNext);
          }),
        );

    const loadedItems$ = combineLatest([
      this.store.pipe(select(selectIsClientFilteredStockPaginationActive)),
      this.store.pipe(select(selectClientFilteredStockItemsCacheForSelectedStore)),
    ]).pipe(
      take(1),
      switchMap(([isClientFiltered, cachedItems]: [boolean, StockItem[]]) => {
        const useClientFilteredItems = isClientFiltered && (cachedItems?.length ?? 0) > 0;
        if (!useClientFilteredItems) {
          return fetchAllPages();
        }
        return of(mapPage(cachedItems)).pipe(
          tap((loadedItems: StockItem[]) => {
            this.store.dispatch(StockManagerActions.setBulkChangeStatus({
              message: `Loaded ${loadedItems.length} matching ${loadedItems.length === 1 ? 'item' : 'items'}…`,
            }));
          }),
        );
      }),
    );

    return this.store.pipe(
      select(selectIsStockGridFilterLoading),
      take(1),
      switchMap((filterLoading: boolean) => {
        if (filterLoading) {
          return throwError(() => new Error(
            'Wait for the current filter to finish loading before applying bulk changes.',
          ));
        }
        return loadedItems$;
      }),
      mergeMap((items: StockItem[]) => (items.length >= BULK_CHANGE_MAX_ITEMS ? tooManyItems() : of(items))),
    );
  }

  /**
   * Checks Firestore supplier details and optionally prompts to auto-fill suppCode.
   */
  private async handleSupplierCodeAutoFillPrompt(stockItem: StockItem, newSupplierCode: string): Promise<void> {
    const storeId = stockItem.storeId;
    const stockItemCode = String(stockItem.code ?? '');
    if (!storeId || !stockItemCode) {
      return;
    }

    try {
      const {multipleSuppliers: firestoreMultipleSuppliers, supplierDetails: firestoreSupplierDetails} =
        await this.collectionSharedStockService.getStockSupplierFieldsByCode(storeId, stockItemCode);

      const rowMultipleSuppliers = Array.isArray(stockItem.multipleSuppliers)
        ? stockItem.multipleSuppliers.map((code: unknown) => String(code))
        : [];
      const multipleSuppliers = firestoreMultipleSuppliers.length > 0
        ? firestoreMultipleSuppliers
        : rowMultipleSuppliers;

      const firestoreHasSupplierDetails = normalizeSupplierDetails(firestoreSupplierDetails).length > 0;
      const supplierDetails = firestoreHasSupplierDetails
        ? firestoreSupplierDetails
        : (stockItem.supplierDetails ?? firestoreSupplierDetails);

      if (!isSupplierInMultipleSuppliers(newSupplierCode, multipleSuppliers)) {
        return;
      }

      const supplierStockCode = findStockCodeForSupplier(newSupplierCode, supplierDetails);
      const mode: SupplierCodeAutoFillModalMode = supplierStockCode ? 'confirm' : 'missing-stock-code';
      const modal = await this.modalController.create({
        component: StockManagerSupplierCodeAutoFillModalComponent,
        componentProps: {
          mode,
          supplierCode: newSupplierCode,
          stockCode: supplierStockCode ?? '',
        },
        cssClass: 'stock-manager-supplier-code-auto-fill-modal-css',
        backdropDismiss: false,
      });
      await modal.present();
      const {data} = await modal.onDidDismiss();
      const result = data as ISupplierCodeAutoFillModalResult | undefined;

      if (result?.doNotAskAgain) {
        this.store.dispatch(StockManagerActions.setDontAskSupplierCodeAutoFillSession());
      }

      if (mode === 'confirm' && result?.action === 'accept' && supplierStockCode) {
        const editedItems = await firstValueFrom(
          this.store.pipe(select(StockManagerSelectors.selectEditedItems)),
        );
        const itemCode = String(stockItem.code ?? '');
        const latestEditedItem = editedItems?.[itemCode] ?? editedItems?.[stockItem.code];
        const baseStockItem: StockItem = {
          ...(latestEditedItem ?? {}),
          ...stockItem,
          code: itemCode || stockItem.code,
        };
        const originalValue = {
          ...(baseStockItem.originalValue ?? {}),
        };
        if (originalValue.suppCode === undefined) {
          originalValue.suppCode = {value: baseStockItem.suppCode ?? ''};
        }
        const updatedStockItem: StockItem = {
          ...baseStockItem,
          originalValue,
          suppCode: supplierStockCode,
          isEdited: true,
        };
        this.store.dispatch(StockManagerActions.setEditedItem({stockItem: updatedStockItem}));
      }
    } catch (error) {
      console.error('[Stock Manager] Supplier code auto-fill check failed:', error);
    }
  }

  private createGetMultiStoreStockItemsEffect(): Observable<Action> & CreateEffectMetadata {
    return createEffect(() =>
      this.actions$.pipe(
      ofType(
        StockManagerActions.getMultiStoreStockItems,
        StockManagerActions.setMultiStoreSelectedStoreIds,
        StockManagerActions.setMultiStoreStockItemFilters,
        StockManagerActions.getAllTypesenseApiKeysForStoresSuccess,
      ),
      withLatestFrom(
        this.store.pipe(select(StockManagerSelectors.selectMultiStoreSelectedStoreIds)),
        this.store.pipe(select(StockManagerSelectors.selectMultiStorePaginationData)),
        this.store.pipe(select(StockManagerSelectors.selectMultiStoreFilters)),
        this.store.pipe(select(StockManagerSelectors.selectMultiStoreSortType)),
        this.store.pipe(select(StockManagerSelectors.selectSearchableFields)),
        this.store.pipe(select(StockManagerSelectors.selectStockManagerApiDocs)),
        this.store.pipe(select(UserStoreSelectors.selectAllUserStores)),
        this.store.pipe(select(selectAppliedAdvancedFilterGroup)),
        this.store.pipe(select(UserAccessSelectors.selectUser)),
        this.store.pipe(select(StockManagerSelectors.selectIsStockManagerMultiStoreTab)),
      ),
      filter(([action, , , , , , , , , , isMultiStoreTab]) =>
        action.type !== StockManagerActions.getAllTypesenseApiKeysForStoresSuccess.type || isMultiStoreTab,
      ),
      switchMap(([
        action,
        selectedStoreIds,
        paginationData,
        filters,
        sortType,
        searchableFields,
        apiDocs,
        allStores,
        advancedFilterGroup,
        user,
      ]) => {
        const storeIds = (selectedStoreIds || []).filter(Boolean);
        const effectiveApiDocs = action.type === StockManagerActions.getAllTypesenseApiKeysForStoresSuccess.type
          && 'apiDocs' in action
          ? action.apiDocs
          : apiDocs;
        if (storeIds.length === 0) {
          if (action.type === StockManagerActions.getAllTypesenseApiKeysForStoresSuccess.type) {
            return EMPTY;
          }
          return of(StockManagerActions.getMultiStoreStockItemsSuccess({
            stockItems: [],
            paginationData: {
              currentPage: 1,
              pageSize: paginationData.pageSize ?? 100,
              totalItems: 0,
              searchedValue: paginationData.searchedValue ?? '',
            },
            facetCounts: {},
            storeColourMap: {},
          }));
        }

        const resetToFirstPage =
          action.type === StockManagerActions.setMultiStoreSelectedStoreIds.type
          || action.type === StockManagerActions.setMultiStoreStockItemFilters.type;
        const currentPage = resetToFirstPage
          ? 1
          : (('currentPage' in action && action.currentPage != null)
            ? action.currentPage
            : (paginationData.currentPage ?? 1));
        const pageSize =
          ('pageSize' in action && action.pageSize != null)
            ? action.pageSize
            : (paginationData.pageSize ?? 100);
        const searchedValue =
          ('searchedValue' in action && action.searchedValue != null)
            ? action.searchedValue
            : (paginationData.searchedValue ?? '');

        if (isMultiStorePageBeyondPrefixCap(currentPage, pageSize)) {
          return of(StockManagerActions.getMultiStoreStockItemsBeyondCap({
            paginationData: {
              currentPage,
              pageSize,
              totalItems: paginationData.totalItems ?? 0,
              searchedValue,
            },
          }));
        }

        const prefixNeeded = getPrefixNeededForPage(currentPage, pageSize);
        const colourMap = buildStoreColourMap(storeIds);
        const resolvedStores = storeIds
          .map((storeId: string) => allStores.find((store: IStore) => store.storeId === storeId))
          .filter((store: IStore | undefined): store is IStore => !!store);
        const stores = resolvedStores.filter((store: IStore) => !!effectiveApiDocs?.[store.storeId]?.searchApiKey);

        if (stores.length === 0) {
          if (resolvedStores.length > 0 && action.type !== StockManagerActions.getAllTypesenseApiKeysForStoresSuccess.type) {
            return this.actions$.pipe(
              ofType(StockManagerActions.getAllTypesenseApiKeysForStoresSuccess),
              take(1),
              map(() => StockManagerActions.getMultiStoreStockItems({
                currentPage,
                pageSize,
                searchedValue,
              })),
            );
          }
          return of(StockManagerActions.getMultiStoreStockItemsSuccess({
            stockItems: [],
            paginationData: {
              currentPage: 1,
              pageSize,
              totalItems: 0,
              searchedValue,
            },
            facetCounts: {},
            storeColourMap: colourMap,
          }));
        }

        const storeSearches = stores.map((store: IStore) => {
          const storeFilters = getStoreScopedFilters(filters, store.storeId);
          if (!storeFilters) {
            return this.typeSenseService.searchStockItemsWithApiKey(
              searchedValue,
              1,
              1,
              store,
              effectiveApiDocs?.[store.storeId]?.searchApiKey || '',
              searchableFields,
              filtersWithoutSupplierSelection(filters),
              sortType,
              advancedFilterGroup ?? undefined,
              undefined,
              '40',
              false,
            ).pipe(
              map((response: TypeSenseSearchResponse<StockItem>) => ({
                rows: [] as IMultiStoreHitRow[],
                found: 0,
                facetCounts: scopeSupplierFacetCountsToStore(
                  supplierFacetCountsOnly(createFacetCountsMap(response?.facet_counts || [])),
                  store.storeId,
                ),
              })),
              catchError((error: unknown) => {
                console.error(`[Stock Manager] Multi-store supplier facets failed for ${store.storeId}`, error);
                return of({
                  rows: [] as IMultiStoreHitRow[],
                  found: 0,
                  facetCounts: {} as IFacetCounts,
                });
              }),
            );
          }
          return this.fetchStorePrefixHits(
            store,
            effectiveApiDocs?.[store.storeId]?.searchApiKey || '',
            searchedValue,
            prefixNeeded,
            searchableFields,
            storeFilters,
            sortType,
            advancedFilterGroup,
          ).pipe(
            map((result: {rows: IMultiStoreHitRow[]; found: number; facetCounts: IFacetCounts}) => ({
              ...result,
              facetCounts: scopeSupplierFacetCountsToStore(result.facetCounts, store.storeId),
            })),
          );
        });

        return forkJoin(storeSearches).pipe(
          map((results) => {
            const allRows: IMultiStoreHitRow[] = [];
            let totalFound = 0;
            const facetMaps: IFacetCounts[] = [];
            results.forEach((result) => {
              allRows.push(...result.rows);
              totalFound += result.found;
              facetMaps.push(result.facetCounts);
            });

            const sorted = sortMultiStoreHits(allRows, sortType, searchedValue.trim().length > 0);
            const start = (Math.max(1, currentPage) - 1) * pageSize;
            const pageRows = sorted.slice(start, start + pageSize).map((row: IMultiStoreHitRow) => row.item);
            const colouredItems = applyStoreColoursToStockItems(pageRows, colourMap);

            return StockManagerActions.getMultiStoreStockItemsSuccess({
              stockItems: addOriginalValueFieldToItems(colouredItems),
              paginationData: {
                currentPage,
                pageSize,
                totalItems: totalFound,
                searchedValue,
              },
              facetCounts: mergeFacetCounts(facetMaps),
              storeColourMap: colourMap,
            });
          }),
          catchError((error) => of(StockManagerActions.getMultiStoreStockItemsFailure({
            error: {
              ...error,
              action: JSON.stringify(action),
              actionType: action.type,
              originalError: error,
              storeIds,
              userId: user?.id,
              message: error?.message || `Multi-store search failed (prefix cap ${MULTI_STORE_PREFIX_CAP}).`,
            },
          }))),
        );
      }),
      ),
    );
  }

  /**
   * Fetches the Typesense prefix needed for the requested global page from each selected store.
   */
  private fetchStorePrefixHits(
    store: IStore,
    searchApiKey: string,
    query: string,
    prefixNeeded: number,
    searchableFields: ISearchableFields,
    filters: Record<string, ISearchableFields>,
    sortType: string,
    advancedFilterGroup: IAdvancedFilterGroup | null,
  ): Observable<{rows: IMultiStoreHitRow[]; found: number; facetCounts: IFacetCounts}> {
    const perPage = MULTI_STORE_TYPESENSE_PAGE_SIZE;
    const pagesNeeded = Math.max(1, Math.ceil(prefixNeeded / perPage));
    const useClientSideFilter = hasStringPresenceAdvancedFilters(advancedFilterGroup);

    if (useClientSideFilter && advancedFilterGroup) {
      return this.fetchStoreHitsForClientSideAdvancedFilter(
        store,
        searchApiKey,
        query,
        prefixNeeded,
        searchableFields,
        filters,
        sortType,
        advancedFilterGroup,
        perPage,
      );
    }

    const pageSearches: Observable<TypeSenseSearchResponse<StockItem>>[] = [];
    for (let page = 1; page <= pagesNeeded; page += 1) {
      pageSearches.push(
        this.typeSenseService.searchStockItemsWithApiKey(
          query,
          page,
          perPage,
          store,
          searchApiKey,
          searchableFields,
          filters,
          sortType,
          advancedFilterGroup ?? undefined,
          undefined,
          '3,4,40,46,_tags,multipleSuppliers',
        ),
      );
    }

    return forkJoin(pageSearches).pipe(
      map((responses: TypeSenseSearchResponse<StockItem>[]) => {
        const rows: IMultiStoreHitRow[] = [];
        responses.forEach((response: TypeSenseSearchResponse<StockItem>) => {
          const mapped = transformTypesenseStockItemsForGrid(
            mapTypeSenseObjectToGeneric<StockItem>(response),
            store,
          );
          (response.hits || []).forEach((hit: TypeSenseHit<StockItem>, index: number) => {
            if (mapped[index]) {
              rows.push({
                item: mapped[index],
                textMatch: hit.text_match ?? 0,
              });
            }
          });
        });
        const firstResponse = responses[0];
        return {
          rows: rows.slice(0, prefixNeeded),
          found: firstResponse?.found ?? 0,
          facetCounts: createFacetCountsMap(firstResponse?.facet_counts || []),
        };
      }),
      catchError((error: unknown) => {
        console.error(`[Stock Manager] Multi-store search failed for ${store.storeId}`, error);
        return of({
          rows: [] as IMultiStoreHitRow[],
          found: 0,
          facetCounts: {} as IFacetCounts,
        });
      }),
    );
  }

  /**
   * String "is empty" and "ends with" filters cannot be evaluated by Typesense. Load all rows
   * matching the server-side part of the filter, apply the complete filter locally, then return
   * the prefix required by the global multi-store merge.
   */
  private fetchStoreHitsForClientSideAdvancedFilter(
    store: IStore,
    searchApiKey: string,
    query: string,
    prefixNeeded: number,
    searchableFields: ISearchableFields,
    filters: Record<string, ISearchableFields>,
    sortType: string,
    advancedFilterGroup: IAdvancedFilterGroup,
    perPage: number,
  ): Observable<{rows: IMultiStoreHitRow[]; found: number; facetCounts: IFacetCounts}> {
    const searchPage = (page: number): Observable<TypeSenseSearchResponse<StockItem>> =>
      this.typeSenseService.searchStockItemsWithApiKey(
        query,
        page,
        perPage,
        store,
        searchApiKey,
        searchableFields,
        filters,
        sortType,
        advancedFilterGroup,
        {omitStringPresence: true},
        '3,4,40,46,_tags,multipleSuppliers',
      );

    return searchPage(1).pipe(
      switchMap((firstResponse: TypeSenseSearchResponse<StockItem>) => {
        const totalPages = Math.max(1, Math.ceil((firstResponse.found ?? 0) / perPage));
        if (totalPages === 1) {
          return of([firstResponse]);
        }
        const remainingSearches: Observable<TypeSenseSearchResponse<StockItem>>[] = [];
        for (let page = 2; page <= totalPages; page += 1) {
          remainingSearches.push(searchPage(page));
        }
        return forkJoin([of(firstResponse), ...remainingSearches]);
      }),
      map((responses: TypeSenseSearchResponse<StockItem>[]) => {
        const rows: IMultiStoreHitRow[] = [];
        responses.forEach((response: TypeSenseSearchResponse<StockItem>) => {
          const mapped = transformTypesenseStockItemsForGrid(
            mapTypeSenseObjectToGeneric<StockItem>(response),
            store,
          );
          (response.hits || []).forEach((hit: TypeSenseHit<StockItem>, index: number) => {
            if (mapped[index]) {
              rows.push({
                item: mapped[index],
                textMatch: hit.text_match ?? 0,
              });
            }
          });
        });

        const matchingItems = new Set(
          applyAdvancedFilterGroupToData(
            rows.map((row: IMultiStoreHitRow): StockItem => row.item),
            advancedFilterGroup,
          ),
        );
        const filteredRows = rows.filter((row: IMultiStoreHitRow): boolean => matchingItems.has(row.item));

        return {
          rows: filteredRows.slice(0, prefixNeeded),
          found: filteredRows.length,
          facetCounts: createFacetCountsMap(responses[0]?.facet_counts || []),
        };
      }),
      catchError((error: unknown) => {
        console.error(`[Stock Manager] Multi-store advanced filter failed for ${store.storeId}`, error);
        return of({
          rows: [] as IMultiStoreHitRow[],
          found: 0,
          facetCounts: {} as IFacetCounts,
        });
      }),
    );
  }
}
